// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

/*Media Query*/
::ng-deep .all-toolcards .innovation-section.toolcards {
  max-width: 740px;
  margin: 20px auto 30px;
  width: 100%;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .innovation-section.toolcards {
    min-height: 0;
  }
}
::ng-deep .all-toolcards .innovation-section.toolcards p {
  font-family: "Museo-300";
  font-size: 15px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .innovation-section.toolcards p {
    font-size: 12px;
    line-height: 20px;
  }
}
::ng-deep .all-toolcards .innovation-section.toolcards p b {
  font-family: "Museo-700";
}
::ng-deep .all-toolcards .innovation-section.toolcards ul {
  font-size: 15px;
  line-height: 24px;
  font-family: "Museo-300";
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .innovation-section.toolcards ul {
    font-size: 12px;
    line-height: 20px;
  }
}
::ng-deep .all-toolcards .innovation-section.toolcards small {
  font-size: 75%;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .innovation-section.toolcards small {
    font-size: 90%;
  }
}
::ng-deep .all-toolcards .innovation-section.toolcards blockquote {
  border: none;
  margin: 0px;
  font-size: 15px;
  padding: 10px 12px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .innovation-section.toolcards blockquote {
    font-size: 12px;
  }
}
::ng-deep .all-toolcards section#mind-mapping .inside img {
  margin-top: 35px;
}
::ng-deep .all-toolcards .toolcards.innovation-section {
  position: relative;
  /* some-specific-style*/
}
::ng-deep .all-toolcards .toolcards.innovation-section .section-top {
  padding: 45px 60px 0px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .section-top {
    padding: 30px 15px 0;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .top-heading {
  font-size: 23px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .top-heading {
    font-size: 20px;
    line-height: 30px;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .top-heading span {
  font-size: 20px;
  display: block;
  margin: 0px;
  line-height: 16px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .top-heading span {
    font-size: 18px;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .sub-heading {
  font-size: 20px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .sub-heading {
    font-size: 17px;
  }
  ::ng-deep .all-toolcards .toolcards.innovation-section .sub-heading br {
    display: none;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .right-heading {
  text-align: right;
  margin: 0px;
  font-size: 70px;
  color: #fff;
  letter-spacing: 4px;
  font-family: "Museo-700";
  opacity: 0.4;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .right-heading {
    font-size: 45px;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .right-heading span {
  font-size: 12px;
  text-transform: uppercase;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .right-heading span {
    font-size: 10px;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section input.input-text {
  border: none;
  width: 100%;
  outline: none;
  font-size: 16px;
  text-indent: 10px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content {
  padding: 40px 60px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content {
    padding: 20px 15px;
  }
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .col-xs-6,
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .col-xs-5,
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .col-xs-4,
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .col-xs-3,
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .col-xs-2,
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .col-xs-8,
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .col-xs-9,
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .col-xs-7 {
    width: 100%;
  }
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .col-xs-offset-6 {
    display: none;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .pcq {
  border-bottom: 2px solid rgb(0, 173, 208);
  margin: 0 0 15px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .pcq .col-xs-6 {
  padding: 0px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside img {
  margin-bottom: 10px;
  width: 100%;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside img {
    display: inherit;
    margin: 15px auto;
    width: auto;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside p {
  margin-bottom: 8px !important;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table {
  width: 100%;
  border: 2px solid rgb(105, 190, 40);
  margin: 25px 0px;
  table-layout: fixed;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table th {
  color: rgb(105, 190, 40);
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table th,
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table td {
  width: 25%;
  border: 1px solid rgb(105, 190, 40);
  text-align: center;
  font-size: 16px;
  height: 35px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table th,
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table td {
    font-size: 14px;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table td:first-child {
  font-size: 12px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table td:first-child {
    font-size: 10px;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-table {
  border: 0;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-table th,
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-table td {
  border: 0;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-table th {
  border-bottom: 2px solid rgb(105, 190, 40);
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-table th:first-child {
  border-right: 2px solid rgb(105, 190, 40);
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-table td {
  border-bottom: 1px solid rgb(105, 190, 40);
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-table td:first-child {
  border-right: 2px solid rgb(105, 190, 40);
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-risk {
  margin-bottom: 60px;
  margin-top: 50px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-risk td {
  vertical-align: top;
  text-align: left;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-risk ul {
  padding: 0px 0 0 10px;
  margin: 0px;
  list-style-type: none;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-risk ul li {
  margin-bottom: 10px;
  font-size: 14px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-risk ul li {
    font-size: 12px;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-assist {
  border: 0;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-assist th,
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-assist td {
  border: 0;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-assist th {
  font-size: 18px;
  border-bottom: 2px solid rgb(245, 67, 89);
  color: rgb(245, 67, 89);
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-assist th:first-child {
  border-right: 2px solid rgb(245, 67, 89);
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-assist th {
    font-size: 16px;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-assist td:first-child {
  border-right: 2px solid rgb(245, 67, 89);
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-assist textarea {
  width: 100%;
  margin: 0px;
  height: 100%;
  background: #fff;
  outline: none;
  min-height: 400px;
  resize: none;
  border: none;
  font-size: 15px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-action {
  border: 2px solid rgb(245, 67, 89);
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-action th,
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-action td {
  border: 0;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-action textarea {
  width: 100%;
  margin: 0px;
  height: 100%;
  background: #fff;
  outline: none;
  min-height: 180px;
  resize: none;
  border: none;
  font-size: 15px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-action th {
  background: rgb(245, 67, 89);
  color: #fff;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.t-action td {
  border-right: 1px dashed rgb(245, 67, 89);
  color: rgb(245, 67, 89);
  height: 160px;
  vertical-align: top;
  text-align: left;
  padding: 10px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .inside table.brain-table tr td {
  height: 200px;
  /* Safari/Chrome, other WebKit */
  /* Firefox, other Gecko */
  box-sizing: border-box;
  /* Opera/IE 8+ */
  border: 5px solid #000000;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content ul {
  padding-left: 15px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .page-footer {
  font-size: 10px !important;
  position: absolute;
  bottom: 10px;
  margin: 0px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .page-footer a {
  font-family: "Museo-700";
  color: #8a8a8a;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .page-footer {
    position: relative;
    bottom: 0;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .cards-content .bg-heading {
  margin: 0px;
  padding: 20px 0px 40px 20px;
  line-height: 25px;
  background: url("https://assets.foursightonline.com/app/images/toolcards/icon-bg.png") no-repeat;
  background-size: contain;
  font-size: 20px;
}
::ng-deep .all-toolcards .toolcards.innovation-section p.clr-text {
  font-size: 23px;
  font-family: "Museo-100";
  line-height: 29px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section p.clr-text {
    font-size: 16px;
    line-height: 24px;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .clr-num {
  display: inline-block;
  font-size: 20px;
  font-family: "Museo-700";
  float: left;
}
::ng-deep .all-toolcards .toolcards.innovation-section .b-box-inside {
  overflow: hidden;
}
::ng-deep .all-toolcards .toolcards.innovation-section .b-box {
  width: 32%;
  margin: 10px 0.5%;
  float: left;
  height: 250px;
  box-sizing: border-box;
  background: transparent;
  background-size: contain;
  position: relative;
}
::ng-deep .all-toolcards .toolcards.innovation-section .b-box.left-border {
  background: url("https://assets.foursightonline.com/app/images/toolcards/right2.png") no-repeat !important;
  background-position: top left !important;
  background-size: contain !important;
}
::ng-deep .all-toolcards .toolcards.innovation-section .b-box.right-border {
  background: url("https://assets.foursightonline.com/app/images/toolcards/left2.png") no-repeat !important;
  background-position: top right !important;
  background-size: contain !important;
}
::ng-deep .all-toolcards .toolcards.innovation-section .b-box .icon {
  font-size: 50px;
  position: absolute;
  top: 50%;
  text-align: center;
  margin-top: -30px;
  left: 0;
  right: 0;
}
::ng-deep .all-toolcards .toolcards.innovation-section .idea {
  padding: 20px 0px;
  margin-bottom: 75px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .idea .right img {
  width: 100px;
  margin-top: 50px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .idea img {
  width: 130px;
  margin-bottom: 15px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .idea .bottom-img img {
  margin-top: 30px;
  display: inline-block;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .idea .bottom-img {
    text-align: center;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .story-board-content {
  overflow: hidden;
  text-align: center;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards .toolcards.innovation-section .story-board-content {
    max-width: 70%;
    margin: 0px auto;
  }
}
::ng-deep .all-toolcards .toolcards.innovation-section .story-board-content img {
  min-height: 120px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .story-board-content p {
  line-height: 16px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .story-board-content figcaption {
  min-height: 90px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .line-border {
  border-bottom: 2px solid;
  padding-bottom: 5px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .line-border--mb {
  margin-bottom: 10px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .alpha-content {
  margin: 0 0 15px;
  position: relative;
  overflow: hidden;
}
::ng-deep .all-toolcards .toolcards.innovation-section .alpha-content span {
  display: inline-block;
  float: left;
  font-size: 30px;
  line-height: 40px;
  width: 44px;
  height: 40px;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  margin: 0 15px 30px 0;
}
::ng-deep .all-toolcards .toolcards.innovation-section .alpha-content p {
  margin: 0px;
  line-height: 16px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .alpha-content.point {
  margin-bottom: 30px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .alpha-content.point span {
  float: none;
  margin: 0px;
}
::ng-deep .all-toolcards .toolcards.innovation-section .alpha-content.point .fa {
  font-size: 20px;
  line-height: 40px;
  margin: 0px 10px;
  color: rgb(105, 190, 40);
  font-weight: 100;
}
::ng-deep .all-toolcards .toolcards.innovation-section .right .alpha-icon {
  width: 100px;
  margin-top: 20px !important;
}
::ng-deep .all-toolcards .toolcards.innovation-section .alpha-icon {
  width: 70px;
  display: inline-block !important;
  margin: 0 0 15px !important;
}
::ng-deep .all-toolcards .toolcards.innovation-section .point-icons {
  margin-top: 90px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify .section-top {
  background: rgb(0, 173, 208);
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify p.clr-text {
  color: rgb(0, 173, 208);
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify .clr-num {
  color: rgb(0, 173, 208);
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify .bg-heading {
  color: rgb(0, 173, 208);
  font-family: "Museo-700";
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify .phrase {
  float: left;
  margin-right: 30px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify .p1 {
  background: url("https://assets.foursightonline.com/app/images/toolcards/p1-bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 15px 10px 35px 10px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify .p2 {
  background: url("https://assets.foursightonline.com/app/images/toolcards/p2-bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 15px 10px 35px 10px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify .p3 {
  background: url("https://assets.foursightonline.com/app/images/toolcards/p3-bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 15px 10px 35px 10px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify .p4 {
  background: url("https://assets.foursightonline.com/app/images/toolcards/p4-bg.png") no-repeat;
  background-size: 100% 100%;
  padding: 15px 10px 35px 10px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify blockquote {
  color: rgb(0, 173, 208);
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify .cards-content span {
  color: rgb(0, 173, 208);
  font-family: "Museo-700";
}
::ng-deep .all-toolcards .toolcards.innovation-section.clarify .bug img {
  width: 55px;
  margin: 0 15px 10px 0px !important;
}
::ng-deep .all-toolcards .toolcards.innovation-section.ideate .section-top {
  background: rgb(255, 121, 0) !important;
}
::ng-deep .all-toolcards .toolcards.innovation-section.ideate p.clr-text {
  color: rgb(255, 121, 0);
}
::ng-deep .all-toolcards .toolcards.innovation-section.ideate .clr-num {
  color: rgb(255, 121, 0);
}
::ng-deep .all-toolcards .toolcards.innovation-section.ideate .bg-heading {
  color: rgb(255, 121, 0);
  font-family: "Museo-700";
}
::ng-deep .all-toolcards .toolcards.innovation-section.ideate blockquote {
  color: rgb(255, 121, 0);
}
::ng-deep .all-toolcards .toolcards.innovation-section.ideate .bg-heading {
  background: url("https://assets.foursightonline.com/app/images/toolcards/2a-bg.png") no-repeat;
  background-size: contain;
  padding: 15px 0 48px 20px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.ideate .alpha-content span {
  background: rgb(255, 121, 0);
  color: #fff !important;
}
::ng-deep .all-toolcards .toolcards.innovation-section.ideate .cards-content span {
  color: rgb(255, 121, 0);
  font-family: "Museo-700";
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop .section-top {
  background: rgb(105, 190, 40);
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop p.clr-text {
  color: rgb(105, 190, 40);
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop .clr-num {
  color: rgb(105, 190, 40);
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop .bg-heading {
  color: rgb(105, 190, 40);
  font-family: "Museo-700";
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop blockquote {
  color: rgb(105, 190, 40);
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop .alpha-content span {
  background: rgb(105, 190, 40);
  color: #fff !important;
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop .alpha-content b {
  color: rgb(105, 190, 40);
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop .cards-content span {
  color: rgb(105, 190, 40);
  font-family: "Museo-700";
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop .target {
  overflow: hidden;
  margin-bottom: 30px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop .target .col-xs-6 {
  padding: 0px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.develop .target p {
  border-bottom: 2px solid rgb(105, 190, 40);
  font-size: 14px;
  line-height: 24px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .section-top {
  background: rgb(245, 67, 89);
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement p.clr-text {
  color: rgb(245, 67, 89);
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .clr-num {
  color: rgb(245, 67, 89);
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .bg-heading {
  color: rgb(245, 67, 89);
  font-family: "Museo-700";
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement blockquote {
  color: rgb(245, 67, 89);
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .alpha-content span {
  background: rgb(245, 67, 89);
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .cards-content span {
  color: rgb(245, 67, 89);
  font-family: "Museo-700";
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .thumb-img {
  max-width: 160px;
  margin-top: 50px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .stake-img {
  max-width: 120px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .time-img {
  max-width: 90px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .action {
  margin-top: 50px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .perform {
  margin: 20px 0px 30px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .dash-icons {
  margin: 30px 0px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .dash-icons .row {
  margin: 15px 0px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .dash-icons p {
  margin-top: 10px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.implement .learn {
  margin: 30px 0px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.gray .section-top {
  background: #fff;
}
::ng-deep .all-toolcards .toolcards.innovation-section.gray .top-heading {
  color: #8a8a8a;
  font-family: "Museo-700";
  font-size: 30px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.gray .cards-content {
  padding-top: 20px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.gray .page-footer {
  position: static;
  margin-top: 25px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.gray .last-footer {
  background: #6c6d70;
  padding: 20px 30px;
  border-top: 25px solid #e6e7e9;
}
::ng-deep .all-toolcards .toolcards.innovation-section.gray .last-footer img {
  width: 200px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.gray .f-img {
  width: 35px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.eos-level {
  margin: 0 0 0 10px;
  color: #333;
}
::ng-deep .all-toolcards .toolcards.innovation-section.eos-level .top-heading {
  color: #333;
  font-size: 30px;
  border: 2px solid;
}
::ng-deep .all-toolcards .toolcards.innovation-section.eos-level .sub-heading {
  font-family: "Museo-700";
  color: #333;
}
::ng-deep .all-toolcards .toolcards.innovation-section.eos-level .row {
  font-size: 16px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.eos-level .row input {
  border: none;
  outline: none;
}
::ng-deep .all-toolcards .toolcards.innovation-section.eos-level .row.top input {
  border-bottom: 2px solid #333;
}
::ng-deep .all-toolcards .toolcards.innovation-section.eos-level .bottom {
  margin-top: 35px;
}
::ng-deep .all-toolcards .toolcards.innovation-section.eos-level .bottom textarea {
  width: 100%;
  height: 100%;
  min-height: 60px;
  overflow: hidden;
  resize: none;
  background: #fff;
}
::ng-deep .all-toolcards .toolcards.innovation-section.eos-level .table-10 {
  width: 100%;
  max-width: 480px;
  margin: 0px auto;
  table-layout: auto;
}
::ng-deep .all-toolcards .toolcards.innovation-section.eos-level .table-10 td {
  padding: 10px 0px;
  vertical-align: top;
}
::ng-deep .all-toolcards .story-board.row .custom {
  min-height: 250px;
}
::ng-deep .all-toolcards #last-page {
  background: #6c6d70;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards #last-page {
    min-height: 600px;
  }
}
::ng-deep .all-toolcards #last-page .page-footer {
  margin: 0px auto;
  left: 0;
  right: 0;
  position: absolute;
}
::ng-deep .all-toolcards #last-page .page-footer a {
  color: #fff;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards section#storyboading .col-xs-4.padding {
    width: 33% !important;
  }
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards section#forced-connections .bg-heading {
    font-size: 17px;
    line-height: 1.1;
  }
  body.body-small ::ng-deep .all-toolcards section#forced-connections .bg-heading {
    padding-right: 24%;
  }
  body.body-small.mini-navbar ::ng-deep .all-toolcards section#forced-connections .bg-heading {
    padding-right: 0%;
  }
}
@media only screen and (max-width: 413px) {
  body.body-small ::ng-deep .all-toolcards section#forced-connections .bg-heading {
    padding-right: 13%;
  }
}
::ng-deep .all-toolcards #first-page {
  background: url("https://assets.foursightonline.com/app/images/toolcards/home-1.png") no-repeat;
  background-size: cover;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards #first-page {
    min-height: 600px;
  }
}
::ng-deep .all-toolcards #first-page .four-tool {
  position: absolute;
  bottom: 25px;
  left: 0;
  width: 100%;
}
::ng-deep .all-toolcards #first-page .four-tool .main-heading {
  color: #fff;
  font-size: 45px;
  line-height: 48px;
  font-family: "Museo-700";
  margin: 0px;
  padding-left: 30px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards #first-page .four-tool .main-heading {
    font-size: 30px;
    line-height: 40px;
  }
}
::ng-deep .all-toolcards #first-page .four-tool .top-heading {
  color: #fff;
  line-height: 30px;
  padding-left: 30px;
}
::ng-deep .all-toolcards #first-page .four-tool .cards-footer {
  background: #6c6d70;
  padding: 20px 30px;
  border-top: 25px solid #e6e7e9;
  margin-top: 25px;
}
::ng-deep .all-toolcards #first-page .four-tool .cards-footer p {
  color: #fff;
  margin: 0px;
  padding-top: 10px;
}
@media (max-width: 500px) {
  ::ng-deep .all-toolcards #first-page .four-tool .cards-footer p {
    text-align: center;
  }
}
::ng-deep .all-toolcards #first-page .four-tool .cards-footer img {
  width: 200px;
}
::ng-deep .all-toolcards #tools-mind {
  padding-top: 140px;
  background: url("https://assets.foursightonline.com/app/images/toolcards/bulb.png") no-repeat;
  background-size: 70%;
  background-color: #e6e7e9;
  background-position: center top;
}
::ng-deep .all-toolcards #tools-mind .top-heading {
  line-height: 36px;
}
::ng-deep .all-toolcards #tools-mind p a {
  color: inherit;
}
::ng-deep .all-toolcards .print-logo {
  display: none;
  position: absolute;
  right: 40px;
  top: 0px;
}
::ng-deep .all-toolcards #tools-index {
  background-color: #e6e7e9;
}
::ng-deep .all-toolcards #tools-index .section-top {
  background-color: #6c6d70;
  color: #fff;
  padding: 30px 60px 0px;
}
@media (max-width: 767px) {
  ::ng-deep .all-toolcards #tools-index .section-top {
    padding: 15px 60px;
  }
}
::ng-deep .all-toolcards #tools-index .section-top .top-heading {
  font-size: 30px;
  text-align: center;
}
::ng-deep .all-toolcards #tools-index .cards-content {
  padding: 20px 35px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .all-toolcards #tools-index .cards-content {
    padding: 15px;
  }
}
::ng-deep .all-toolcards #tools-index .cards-content .col-xs-6 {
  padding: 20px;
}
::ng-deep .all-toolcards #tools-index .cards-content .clarify {
  background-color: rgb(0, 173, 208);
}
::ng-deep .all-toolcards #tools-index .cards-content .ideate {
  background: rgb(255, 121, 0);
}
::ng-deep .all-toolcards #tools-index .cards-content .develop {
  background: rgb(105, 190, 40);
}
::ng-deep .all-toolcards #tools-index .cards-content .implement {
  background: rgb(245, 67, 89);
}
::ng-deep .all-toolcards #tools-index .cards-content .sub-heading {
  color: #fff;
}
::ng-deep .all-toolcards #tools-index .cards-content p span {
  color: #fff;
}
::ng-deep .all-toolcards #tools-index .cards-content p a {
  color: #fff;
  display: inline-block;
  padding-left: 5px;
}

@media print {
  ::ng-deep .all-toolcards .innovation-section .section-top .top-heading,
  ::ng-deep .all-toolcards .innovation-section .section-top span {
    color: #fff !important;
  }
  ::ng-deep .all-toolcards .innovation-section .section-top .right-heading,
  ::ng-deep .all-toolcards .innovation-section .section-top span {
    color: #fff !important;
  }
  ::ng-deep .all-toolcards .innovation-section .cards-content {
    padding-top: 10px !important;
  }
  ::ng-deep .all-toolcards .toolcards.innovation-section.ideate p.clr-text,
  ::ng-deep .all-toolcards .toolcards.innovation-section.ideate .sub-heading {
    color: rgb(255, 121, 0) !important;
  }
  ::ng-deep .all-toolcards a.print-button {
    display: none;
  }
  ::ng-deep .all-toolcards input {
    color: rgb(255, 121, 0) !important;
  }
}
::ng-deep .tdq {
  --bg-clr: #E2F3F9;
  --p-clr: #000000CC;
  --id-clr: #FFEFE1;
  flex-wrap: nowrap;
}
::ng-deep .tdq__head h1 span {
  top: -5px;
  left: 30px;
  text-transform: none;
}
::ng-deep .tdq__fr {
  padding: 23px;
  font-size: 24px;
  background-color: var(--bg-clr);
}
::ng-deep .tdq__fr--clrid {
  background-color: var(--id-clr);
}
::ng-deep .tdq__body {
  padding: 0 10px 50px;
  width: 100%;
}
::ng-deep .tdq__body--pdn {
  padding-bottom: 0;
}
::ng-deep .tdq__body--wd {
  width: 50%;
}
::ng-deep .tdq__body-negml {
  margin-left: -10px;
}
::ng-deep .tdq__body--ml {
  margin-left: 50px !important;
}
::ng-deep .tdq__body--ff3 {
  font-family: "Museo-300" !important;
}
::ng-deep .tdq__body--ff7 {
  font-family: "Museo-700" !important;
}
::ng-deep .tdq__body--clrb {
  color: var(--p-clr) !important;
}
::ng-deep .tdq__body p {
  color: var(--p-clr);
  padding-bottom: 5px;
}
::ng-deep .tdq__body p b {
  color: var(--p-clr);
}
::ng-deep .tdq__body .sub-heading::before {
  content: "";
  width: 30px;
  background-color: rgb(0, 173, 208);
  height: 5px;
  position: absolute;
  bottom: -10px;
}
::ng-deep .tdq__body .sub-heading--clrid::before {
  background-color: rgb(255, 121, 0);
  content: "";
  width: 30px;
  height: 5px;
  position: absolute;
  bottom: -10px;
}

::ng-deep .tlcrd__typ .tlcrd-hdr {
  color: #FFFFFF;
  font-family: "Museo-700";
  background-color: #06A6CE;
}
::ng-deep .tlcrd__typ .tlcrd-hdr__cntnt h2 {
  margin-top: 0;
  font-size: 30px;
  line-height: 1.5;
  text-transform: capitalize;
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-hdr__cntnt h2 {
    font-size: 24px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-hdr__cntnt--rght h1 {
  font-size: 65px;
  color: rgba(255, 255, 255, 0.4);
  margin-top: 10px;
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-hdr__cntnt--rght h1 {
    font-size: 50px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-hdr__cntnt--rght h1 .typ {
  left: 50%;
  top: -15px;
  width: 100%;
  font-size: 15px;
  line-height: 27px;
  transform: translateX(-50%);
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-hdr__cntnt--rght h1 .typ {
    font-size: 12px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-hdr__cntnt--rght {
    order: 1;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-hdr__cntnt {
    order: 2;
  }
}
::ng-deep .tlcrd__typ .tlcrd-hdr--btm {
  font-size: 20px;
  line-height: 1.2;
  color: #1DA6CE;
  font-family: "Museo-300";
  background-color: #E2F3F9;
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-hdr--btm {
    font-size: 16px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body {
  color: rgba(0, 0, 0, 0.8);
  font-family: "Museo-700";
}
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng h3 {
  font-size: 22px;
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng h3 {
    font-size: 18px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng h3:before {
  content: "";
  width: 30px;
  height: 4px;
  bottom: -15px;
  position: absolute;
  background-color: #06A6CE;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng h3 span {
  font-size: 17px;
  color: #06A6CE;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng--sml h4 {
  font-size: 18px;
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng--sml h4 {
    font-size: 16px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng--sml h4:before {
  left: 0;
  top: 4px;
  width: 8px;
  height: 8px;
  content: "";
  position: absolute;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.8);
}
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng--sml h4 span {
  display: block;
  font-size: 15px;
  font-weight: 300;
  font-family: "Museo-300";
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng--sml h4 span {
    font-size: 12px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng--nostyl h3:before,
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng--nostyl h4:before {
  display: none;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__hdng--clrd h3 {
  color: #06A6CE;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__txt {
  font-size: 18px;
  font-family: "Museo-300";
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__txt {
    font-size: 16px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__txt--bold {
  font-size: 18px;
  font-family: "Museo-regular";
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk .tlcrd-body__txt--bold {
    font-size: 16px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--qt .tlcrd-body__qt {
  color: #06A6CE;
  font-size: 16px;
  font-family: "Museo-700";
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--qt .tlcrd-body__qt {
    font-size: 14px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--qt .tlcrd-body__qt--athr {
  font-size: 14px;
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--qt .tlcrd-body__qt--athr {
    font-size: 12px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--ftr {
  bottom: 0;
  color: rgba(0, 0, 0, 0.8);
  font-size: 10px;
  line-height: 17px;
  font-family: "Museo-300";
}
@media only screen and (max-width: 1199px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--ftr {
    position: relative;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--ftr a {
  color: rgba(0, 0, 0, 0.8);
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst ul {
  font-size: 16px;
  font-family: "Museo-300";
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst ul li {
  position: relative;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst ul li:before {
  top: 8px;
  width: 8px;
  left: -18px;
  content: "";
  height: 8px;
  border-radius: 50%;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst ul li span {
  font-family: "Museo-300";
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst ul li span.clr {
  margin: 0;
  display: block;
  color: #06A6CE;
  font-family: "Museo-700";
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst ul.clrd li {
  color: #06A6CE;
  font-family: "Museo-700";
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--b-sml ul li:before {
  width: 5px;
  height: 5px;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--clrd ul li:before {
  background-color: #06A6CE;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--nostyl ul li:before {
  display: none;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst .blank ul {
  color: #06A6CE;
  font-family: "Museo-700";
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst .blank ul li {
  position: relative;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst .blank ul li:after {
  bottom: 0;
  left: 85px;
  width: 70%;
  content: "";
  height: 2px;
  position: absolute;
  background-color: #06A6CE;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst .blank ul li:after {
    width: 55%;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul {
  font-size: 20px;
  font-family: "Museo-700";
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul li {
  padding-left: 40px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul li {
    padding-left: 20px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul li span {
  font-size: 18px;
  display: block;
  font-family: "Museo-300";
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul li span.cstmzd-blts {
  top: -10px;
  left: -25px;
  width: 50px;
  height: 50px;
  padding: 8px;
  font-size: 25px;
  color: #FFFFFF;
  border-radius: 50%;
  text-align: center;
  font-family: "Museo-700";
  background-color: #06A6CE;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul li span.cstmzd-blts {
    top: 0;
    width: 28px;
    height: 28px;
    padding: 4px;
    font-size: 12px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul li:not(:last-child) span {
  padding-bottom: 25px;
  border-bottom: 1px solid #E7E7E8;
}
@media only screen and (max-width: 991px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul li:not(:last-child) span {
    font-size: 14px;
    padding-bottom: 10px;
  }
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul {
    font-size: 16px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--arw span {
  display: block;
  color: #06A6CE;
  font-size: 22px;
  margin-bottom: 20px;
  font-family: "Museo-700";
  border-bottom: 1px solid #06A6CE;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--arw span:nth-child(2) {
  padding-top: 20px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--arw span {
    font-size: 18px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--tbl .tlcrd-body__tbl {
  overflow: auto;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--tbl .tlcrd-body__tbl table {
  width: 100%;
  font-size: 16px;
  line-height: 1.3;
  font-family: "Museo-300";
  border-collapse: collapse;
  border: 2px solid #06A6CE;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--tbl .tlcrd-body__tbl table th,
::ng-deep .tlcrd__typ .tlcrd-body__blk--tbl .tlcrd-body__tbl table td {
  position: relative;
  padding: 20px 15px;
  border: 2px solid #06A6CE;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--tbl .tlcrd-body__tbl table th .row-info,
::ng-deep .tlcrd__typ .tlcrd-body__blk--tbl .tlcrd-body__tbl table td .row-info {
  top: 2px;
  left: 2px;
  color: #06A6CE;
  font-size: 22px;
  position: absolute;
  text-align: center;
  font-family: "Museo-700";
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--pnts ul {
  border-radius: 20px;
  border: 9px solid #E7E7E8;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--pnts ul li {
  width: 50px;
  height: 50px;
  padding: 8px;
  font-size: 25px;
  color: #FFFFFF;
  border-radius: 50%;
  text-align: center;
  position: relative;
  background-color: #06A6CE;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--pnts ul li:not(:last-child) {
  margin-right: 50px;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--pnts ul li:not(:last-child):after {
  content: "+";
  top: 50%;
  right: -31px;
  font-size: 20px;
  position: absolute;
  color: #8A8A8A;
  transform: translateY(-50%);
}
@media (max-width: 1440px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--pnts ul li:not(:last-child):after {
    right: -25px;
  }
}
@media (max-width: 1440px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--pnts ul li:not(:last-child) {
    margin-right: 50px;
  }
}
@media (max-width: 1440px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--pnts ul li {
    width: 28px;
    height: 28px;
    padding: 6px;
    font-size: 12px;
  }
}
@media (max-width: 1440px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--pnts ul {
    border-width: 4px;
  }
}
@media (max-width: 1440px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--pnts .tlcrd-body__txt {
    font-size: 16px;
  }
}
@media (max-width: 991px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--pnts .tlcrd-body__txt {
    font-size: 14px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--olst ol {
  font-size: 20px;
  font-family: "Museo-700";
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--olst ol li {
  padding-left: 15px;
}
::ng-deep .tlcrd__typ .tlcrd-body__blk--olst ol li span {
  display: block;
  font-size: 16px;
  font-family: "Museo-300";
}
@media only screen and (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--olst ol li {
    padding-left: 10px;
  }
}
@media (min-width: 992px) and (max-width: 1199px), (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body__blk--olst ol {
    font-size: 16px;
  }
}
::ng-deep .tlcrd__typ .tlcrd-body .btn-grp {
  top: 0;
  right: 30px;
}
::ng-deep .tlcrd__typ .tlcrd-body .btn-grp a {
  padding: 10px 15px;
  border-radius: 5px;
  color: #8A8A8A;
  border: 1px solid #8A8A8A;
}
::ng-deep .tlcrd__typ .tlcrd-body .btn-grp a i {
  color: #06A6CE;
}
@media only screen and (max-width: 767px) {
  ::ng-deep .tlcrd__typ .tlcrd-body .btn-grp {
    top: 0;
    right: 0;
    position: relative;
  }
}
::ng-deep .tlcrd__typ--id .tlcrd-hdr {
  background-color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-hdr--btm {
  color: rgba(252, 131, 2, 0.8);
  background-color: #FFEFE1;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk .tlcrd-body__hdng h3:before {
  background-color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk .tlcrd-body__hdng h3 span {
  color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk .tlcrd-body__hdng--clrd h3 {
  color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--qt .tlcrd-body__qt {
  color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--lst .tlcrd-body__lst ul li span.clr {
  color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--lst .tlcrd-body__lst ul.clrd li {
  color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--lst .tlcrd-body__lst--clrd ul li:before {
  background-color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--lst .tlcrd-body__lst .blank ul {
  color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--lst .tlcrd-body__lst .blank ul li:after {
  background-color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul li span.cstmzd-blts {
  background-color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--arw span {
  color: #FC8302;
  border-bottom: 1px solid #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--tbl .tlcrd-body__tbl table {
  border: 2px solid #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--tbl .tlcrd-body__tbl table th,
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--tbl .tlcrd-body__tbl table td {
  border: 2px solid #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--tbl .tlcrd-body__tbl table th .row-info,
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--tbl .tlcrd-body__tbl table td .row-info {
  color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body__blk--pnts ul li {
  background-color: #FC8302;
}
::ng-deep .tlcrd__typ--id .tlcrd-body .btn-grp a i {
  color: #FC8302;
}
::ng-deep .tlcrd__typ--dv .tlcrd-hdr {
  background-color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-hdr--btm {
  color: #64BD47;
  background-color: #ECF5E8;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body {
  color: rgba(0, 0, 0, 0.8);
  font-family: "Museo-700";
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk .tlcrd-body__hdng h3:before {
  background-color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk .tlcrd-body__hdng h3 span {
  color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk .tlcrd-body__hdng--clrd h3 {
  color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--qt .tlcrd-body__qt {
  color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--lst .tlcrd-body__lst ul li span.clr {
  color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--lst .tlcrd-body__lst ul.clrd li {
  color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--lst .tlcrd-body__lst--clrd ul li:before {
  background-color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--lst .tlcrd-body__lst .blank ul {
  color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--lst .tlcrd-body__lst .blank ul li:after {
  background-color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul li span.cstmzd-blts {
  background-color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--arw span {
  color: #7BBC43;
  border-bottom: 1px solid #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--tbl .tlcrd-body__tbl table {
  border: 2px solid #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--tbl .tlcrd-body__tbl table th,
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--tbl .tlcrd-body__tbl table td {
  border: 2px solid #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--tbl .tlcrd-body__tbl table th .row-info,
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--tbl .tlcrd-body__tbl table td .row-info {
  color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body__blk--pnts ul li {
  background-color: #7BBC43;
}
::ng-deep .tlcrd__typ--dv .tlcrd-body .btn-grp a i {
  color: #7BBC43;
}
::ng-deep .tlcrd__typ--im .tlcrd-hdr {
  background-color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-hdr--btm {
  color: #FC485C;
  background-color: #FDE9E5;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk .tlcrd-body__hdng h3:before {
  background-color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk .tlcrd-body__hdng h3 span {
  color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk .tlcrd-body__hdng--clrd h3 {
  color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--qt .tlcrd-body__qt {
  color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--lst .tlcrd-body__lst ul li span.clr {
  color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--lst .tlcrd-body__lst ul.clrd li {
  color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--lst .tlcrd-body__lst--clrd ul li:before {
  background-color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--lst .tlcrd-body__lst .blank ul {
  color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--lst .tlcrd-body__lst .blank ul li:after {
  background-color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--lst .tlcrd-body__lst--styled ul li span.cstmzd-blts {
  background-color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--arw span {
  color: #FC485C;
  border-bottom: 1px solid #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--tbl .tlcrd-body__tbl table {
  border: 2px solid #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--tbl .tlcrd-body__tbl table th,
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--tbl .tlcrd-body__tbl table td {
  border: 2px solid #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--tbl .tlcrd-body__tbl table th .row-info,
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--tbl .tlcrd-body__tbl table td .row-info {
  color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body__blk--pnts ul li {
  background-color: #FC485C;
}
::ng-deep .tlcrd__typ--im .tlcrd-body .btn-grp a i {
  color: #FC485C;
}

::ng-deep .tpdfbtn {
  padding-inline: 32px;
}
@media (max-width: 1199px) {
  ::ng-deep .tpdfbtn {
    padding-right: 8px !important;
  }
}
::ng-deep .tpdfbtn a {
  padding: 3px 9px 6px;
  border-radius: 4px;
}
@media (max-width: 1199px) {
  ::ng-deep .tpdfbtn--pr {
    padding-right: 22px !important;
  }
}
@media (max-width: 1199px) {
  ::ng-deep .tpdfbtn--phrs {
    padding-right: 0px !important;
  }
  ::ng-deep .tpdfbtn--phrs a {
    padding-right: 5px;
  }
}

::ng-deep .f-flex.prev-next a {
  padding: 5px 15px;
  background-color: #fff;
  border: 1px solid #fff;
  margin-left: 5px;
  color: #676a6c;
  border-radius: 4px;
  font-weight: 600;
  margin-bottom: 5px;
  min-width: 65px;
}
::ng-deep .f-flex.prev-next a:hover {
  background-color: #ccc;
  border-color: #ccc;
}
@media (max-width: 767px) {
  ::ng-deep .f-flex.prev-next a {
    margin-bottom: 0;
  }
}

::ng-deep .page-heading__pdr {
  padding-right: 35px !important;
}
@media (max-width: 1199px) {
  ::ng-deep .page-heading__pdr {
    padding-right: 17px !important;
  }
}
@media (max-width: 1199px) {
  ::ng-deep .page-heading__pdr--rt {
    padding-right: 30px !important;
  }
}
@media (max-width: 1199px) {
  ::ng-deep .page-heading__pdr--phrs {
    padding-right: 3px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/toolcards/toolcards.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AAxXA,cAAA;AAWE;EACE,gBAAA;EACA,sBAAA;EAMA,WAAA;AA4WJ;AA3XI;EAOF;IAKI,aAAA;EAmXJ;AACF;AA/WI;EACE,wBD1CK;EC2CL,eAAA;AAiXN;AApYI;EAiBA;IAKI,eAAA;IACA,iBAAA;EAkXN;AACF;AAhXM;EACE,wBDhDG;ACkaX;AA9WI;EACE,eAAA;EACA,iBAAA;EACA,wBD1DK;AC0aX;AAlZI;EA+BA;IAMI,eAAA;IACA,iBAAA;EAiXN;AACF;AA9WI;EACE,cAAA;AAgXN;AA3ZI;EA0CA;IAII,cAAA;EAiXN;AACF;AA9WI;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAgXN;AAtaI;EAkDA;IAOI,eAAA;EAiXN;AACF;AA7WE;EACE,gBAAA;AA+WJ;AA3WI;EACE,kBAAA;EAmjBA,uBAAA;AArMN;AA5WM;EACE,sBAAA;AA8WR;AArbI;EAsEE;IAII,oBAAA;EA+WR;AACF;AA5WM;EACE,eAAA;AA8WR;AA7bI;EA8EE;IAII,eAAA;IACA,iBAAA;EA+WR;AACF;AA7WQ;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,iBAAA;AA+WV;AAzcI;EAsFI;IAOI,eAAA;EAgXV;AACF;AA5WM;EACE,eAAA;AA8WR;AAjdI;EAkGE;IAII,eAAA;EA+WR;EA7WQ;IACE,aAAA;EA+WV;AACF;AA3WM;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,WDrEW;ECsEX,mBAAA;EACA,wBDzIG;EC0IH,YAAA;AA6WR;AAleI;EA8GE;IAUI,eAAA;EA8WR;AACF;AA5WQ;EACE,eAAA;EACA,yBAAA;AA8WV;AA3eI;EA2HI;IAKI,eAAA;EA+WV;AACF;AA3WM;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;AA6WR;AA1WM;EACE,kBAAA;AA4WR;AA1fI;EA6IE;IAII,kBAAA;EA6WR;EA3WQ;;;;;;;;IAQE,WAAA;EA6WV;EA1WQ;IACE,aAAA;EA4WV;AACF;AAzWQ;EACE,cAAA;EACA,cAAA;EACA,eAAA;AA2WV;AAxWQ;EACE,yCAAA;EACA,gBAAA;AA0WV;AAxWU;EACE,YAAA;AA0WZ;AArWU;EACE,mBAAA;EACA,WAAA;AAuWZ;AA5hBI;EAmLM;IAKI,gBAAA;IACA,iBAAA;IACA,WAAA;EAwWZ;AACF;AArWU;EACE,6BAAA;AAuWZ;AApWU;EACE,WAAA;EACA,mCAAA;EACA,gBAAA;EACA,mBAAA;AAsWZ;AApWY;EACE,wBD5ME;ACkjBhB;AAnWY;;EAEE,UAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AAqWd;AAvjBI;EA4MQ;;IASI,eAAA;EAuWd;AACF;AApWY;EACE,eAAA;AAsWd;AAhkBI;EAyNQ;IAII,eAAA;EAuWd;AACF;AApWY;EACE,SAAA;AAsWd;AApWc;;EAEE,SAAA;AAsWhB;AAnWc;EACE,0CAAA;AAqWhB;AAnWgB;EACE,yCAAA;AAqWlB;AAjWc;EACE,0CAAA;AAmWhB;AAjWgB;EACE,yCAAA;AAmWlB;AA9VY;EACE,mBAAA;EACA,gBAAA;AAgWd;AA9Vc;EACE,mBAAA;EACA,gBAAA;AAgWhB;AA7Vc;EACE,qBAAA;EACA,WAAA;EACA,qBAAA;AA+VhB;AA7VgB;EACE,mBAAA;EACA,eAAA;AA+VlB;AAzmBI;EAwQY;IAKI,eAAA;EAgWlB;AACF;AA3VY;EACE,SAAA;AA6Vd;AA3Vc;;EAEE,SAAA;AA6VhB;AA1Vc;EACE,eAAA;EACA,yCAAA;EACA,uBDhSE;AC4nBlB;AA1VgB;EACE,wCAAA;AA4VlB;AA7nBI;EA2RU;IAUI,eAAA;EA4VhB;AACF;AAxVgB;EACE,wCAAA;AA0VlB;AAtVc;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBDtQG;ECuQH,aAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAwVhB;AApVY;EACE,kCAAA;AAsVd;AApVc;;EAEE,SAAA;AAsVhB;AAnVc;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBD3RG;EC4RH,aAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAqVhB;AAlVc;EACE,4BDnVE;ECoVF,WDrSG;ACynBnB;AAjVc;EACE,yCAAA;EACA,uBDzVE;EC0VF,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAmVhB;AA9Uc;EACE,aAAA;EACA,gCAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;AAgVhB;AAzUQ;EACE,kBAAA;AA2UV;AAxUQ;EACE,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA0UV;AAxUU;EACE,wBD7YD;EC8YC,cAAA;AA0UZ;AAnsBI;EAiXI;IAYI,kBAAA;IACA,SAAA;EA0UV;AACF;AAvUQ;EACE,WAAA;EACA,2BAAA;EACA,iBAAA;EACA,gGAAA;EACA,wBAAA;EACA,eAAA;AAyUV;AArUM;EACE,eAAA;EACA,wBDvaG;ECwaH,iBAAA;AAuUR;AAttBI;EA4YE;IAMI,eAAA;IACA,iBAAA;EAwUR;AACF;AArUM;EACE,qBAAA;EACA,eAAA;EACA,wBD/aG;ECgbH,WAAA;AAuUR;AApUM;EACE,gBAAA;AAsUR;AAnUM;EACE,UAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kBAAA;AAqUR;AAnUQ;EACE,0GAAA;EACA,wCAAA;EACA,mCAAA;AAqUV;AAlUQ;EACE,yGAAA;EACA,yCAAA;EACA,mCAAA;AAoUV;AAjUQ;EACE,eAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,OAAA;EACA,QAAA;AAmUV;AA/TM;EACE,iBAAA;EACA,mBAAA;AAiUR;AA/TQ;EACE,YAAA;EACA,gBAAA;AAiUV;AA9TQ;EACE,YAAA;EACA,mBAAA;AAgUV;AA5TU;EACE,gBAAA;EACA,qBAAA;AA8TZ;AAlxBI;EAidI;IAOI,kBAAA;EA8TV;AACF;AA1TM;EAUE,gBAAA;EACA,kBAAA;AAmTR;AA3xBI;EA6dE;IAEI,cAAA;IACA,gBAAA;EAgUR;AACF;AA9TQ;EACE,iBAAA;AAgUV;AA1TQ;EACE,iBAAA;AA4TV;AAzTQ;EACE,gBAAA;AA2TV;AAvTM;EACE,wBAAA;EACA,mBAAA;AAyTR;AAvTQ;EACE,mBAAA;AAyTV;AArTM;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AAuTR;AArTQ;EACE,qBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WD5dS;EC6dT,kBAAA;EACA,qBAAA;AAuTV;AApTQ;EACE,WAAA;EACA,iBAAA;AAsTV;AAnTQ;EACE,mBAAA;AAqTV;AAnTU;EACE,WAAA;EACA,WAAA;AAqTZ;AAlTU;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,wBDliBI;ECmiBJ,gBAAA;AAoTZ;AA9SQ;EACE,YAAA;EACA,2BAAA;AAgTV;AA3SM;EACE,WAAA;EACA,gCAAA;EACA,2BAAA;AA6SR;AA1SM;EACE,gBAAA;AA4SR;AAxSQ;EACE,4BD9jBM;ACw2BhB;AAvSQ;EACE,uBDlkBM;AC22BhB;AAtSQ;EACE,uBDtkBM;AC82BhB;AArSQ;EACE,uBD1kBM;EC2kBN,wBD3lBC;ACk4BX;AApSQ;EACE,WAAA;EACA,kBAAA;AAsSV;AAnSQ;EACE,8FAAA;EACA,0BAAA;EACA,4BAAA;AAqSV;AAlSQ;EACE,8FAAA;EACA,0BAAA;EACA,4BAAA;AAoSV;AAjSQ;EACE,8FAAA;EACA,0BAAA;EACA,4BAAA;AAmSV;AAhSQ;EACE,8FAAA;EACA,0BAAA;EACA,4BAAA;AAkSV;AA/RQ;EACE,uBD5mBM;AC64BhB;AA7RU;EACE,uBDjnBI;ECknBJ,wBDloBD;ACi6BX;AA3RQ;EACE,WAAA;EACA,kCAAA;AA6RV;AAvRQ;EACE,uCAAA;AAyRV;AAtRQ;EACE,uBDloBK;AC05Bf;AArRQ;EACE,uBDtoBK;AC65Bf;AApRQ;EACE,uBD1oBK;EC2oBL,wBD5pBC;ACk7BX;AAnRQ;EACE,uBD/oBK;ACo6Bf;AAlRQ;EACE,8FAAA;EACA,wBAAA;EACA,yBAAA;AAoRV;AAhRU;EACE,4BD1pBG;EC2pBH,sBAAA;AAkRZ;AA7QU;EACE,uBDjqBG;ECkqBH,wBDnrBD;ACk8BX;AAzQQ;EACE,6BDxqBM;ACm7BhB;AAxQQ;EACE,wBD5qBM;ACs7BhB;AAvQQ;EACE,wBDhrBM;ACy7BhB;AAtQQ;EACE,wBDprBM;ECqrBN,wBDvsBC;AC+8BX;AArQQ;EACE,wBDzrBM;ACg8BhB;AAnQU;EACE,6BD9rBI;EC+rBJ,sBAAA;AAqQZ;AAlQU;EACE,wBDnsBI;ACu8BhB;AA/PU;EACE,wBDzsBI;EC0sBJ,wBD5tBD;AC69BX;AA7PQ;EACE,gBAAA;EACA,mBAAA;AA+PV;AA7PU;EACE,YAAA;AA+PZ;AA5PU;EACE,0CAAA;EACA,eAAA;EACA,iBAAA;AA8PZ;AAxPQ;EACE,4BD/tBQ;ACy9BlB;AAvPQ;EACE,uBDnuBQ;AC49BlB;AAtPQ;EACE,uBDvuBQ;AC+9BlB;AArPQ;EACE,uBD3uBQ;EC4uBR,wBD/vBC;ACs/BX;AApPQ;EACE,uBDhvBQ;ACs+BlB;AAnPQ;EACE,4BDpvBQ;ACy+BlB;AAjPU;EACE,uBDzvBM;EC0vBN,wBD7wBD;ACggCX;AA/OQ;EACE,gBAAA;EACA,gBAAA;AAiPV;AA9OQ;EACE,gBAAA;AAgPV;AA7OQ;EACE,eAAA;AA+OV;AA5OQ;EACE,gBAAA;AA8OV;AA3OQ;EACE,qBAAA;AA6OV;AA1OQ;EACE,gBAAA;AA4OV;AA1OU;EACE,gBAAA;AA4OZ;AAzOU;EACE,gBAAA;AA2OZ;AAvOQ;EACE,gBAAA;AAyOV;AApOQ;EACE,gBDvvBS;AC69BnB;AAlOQ;EACE,cAAA;EACA,wBD/zBC;ECg0BD,eAAA;AAoOV;AAjOQ;EACE,iBAAA;AAmOV;AAhOQ;EACE,gBAAA;EACA,gBAAA;AAkOV;AA/NQ;EACE,mBAAA;EACA,kBAAA;EACA,8BAAA;AAiOV;AA/NU;EACE,YAAA;AAiOZ;AA7NQ;EACE,WAAA;AA+NV;AA3NM;EACE,kBAAA;EACA,WAAA;AA6NR;AA3NQ;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AA6NV;AA1NQ;EACE,wBDt2BC;ECu2BD,WAAA;AA4NV;AAzNQ;EACE,eAAA;AA2NV;AAzNU;EACE,YAAA;EACA,aAAA;AA2NZ;AAvNY;EACE,6BAAA;AAyNd;AApNQ;EACE,gBAAA;AAsNV;AApNU;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBDh0BO;ACshCnB;AAlNQ;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAoNV;AAlNU;EACE,iBAAA;EACA,mBAAA;AAoNZ;AA7ME;EACE,iBAAA;AA+MJ;AA5ME;EACE,mBAAA;AA8MJ;AAnlCI;EAo4BF;IAII,iBAAA;EA+MJ;AACF;AA7MI;EACE,gBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;AA+MN;AA7MM;EACE,WDr2BW;ACojCnB;AAjmCI;EAu5BF;IAEI,qBAAA;EA4MJ;AACF;AAtmCI;EA65BF;IAEI,eAAA;IACA,gBAAA;EA2MJ;EAzMI;IACE,kBAAA;EA2MN;EAxMI;IACE,iBAAA;EA0MN;AACF;AAvMI;EACE;IACE,kBAAA;EAyMN;AACF;AArME;EACE,+FAAA;EACA,sBAAA;AAuMJ;AA3nCI;EAk7BF;IAKI,iBAAA;EAwMJ;AACF;AAtMI;EACE,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;AAwMN;AAtMM;EACE,WDp5BW;ECq5BX,eAAA;EACA,iBAAA;EACA,wBDz9BG;EC09BH,WAAA;EACA,kBAAA;AAwMR;AA9oCI;EAg8BE;IASI,eAAA;IACA,iBAAA;EAyMR;AACF;AAtMM;EACE,WDl6BW;ECm6BX,iBAAA;EACA,kBAAA;AAwMR;AArMM;EACE,mBAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;AAuMR;AArMQ;EACE,WD96BS;EC+6BT,WAAA;EACA,iBAAA;AAuMV;AApqCI;EA09BI;IAMI,kBAAA;EAwMV;AACF;AArMQ;EACE,YAAA;AAuMV;AAjME;EACE,kBAAA;EACA,6FAAA;EACA,oBAAA;EACA,yBAAA;EACA,+BAAA;AAmMJ;AAjMI;EACE,iBAAA;AAmMN;AAhMI;EACE,cAAA;AAkMN;AA9LE;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AAgMJ;AA7LE;EACE,yBAAA;AA+LJ;AA7LI;EACE,yBAAA;EACA,WD19Ba;EC29Bb,sBAAA;AA+LN;AA7LM;EALF;IAMI,kBAAA;EAgMN;AACF;AA9LM;EACE,eAAA;EACA,kBAAA;AAgMR;AA5LI;EACE,kBAAA;AA8LN;AA5LM;EAHF;IAII,aAAA;EA+LN;AACF;AA7LM;EACE,aAAA;AA+LR;AA5LM;EACE,kCDriCQ;ACmuChB;AA3LM;EACE,4BDxiCO;ACquCf;AA1LM;EACE,6BD3iCQ;ACuuChB;AAzLM;EACE,4BD9iCU;ACyuClB;AAxLM;EACE,WDngCW;AC6rCnB;AAtLQ;EACE,WDxgCS;ACgsCnB;AArLQ;EACE,WD5gCS;EC6gCT,qBAAA;EACA,iBAAA;AAuLV;;AAhLA;EAMQ;;IAEE,sBAAA;EA8KR;EA3KM;;IAEE,sBAAA;EA6KR;EAxKI;IACE,4BAAA;EA0KN;EApKI;;IAEE,kCAAA;EAsKN;EAlKE;IACE,aAAA;EAoKJ;EAjKE;IACE,kCAAA;EAmKJ;AACF;AA9JA;EACE,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAgKF;AA1JM;EACE,SAAA;EACA,UAAA;EACA,oBAAA;AA4JR;AAvJE;EACE,aAAA;EACA,eAAA;EACA,+BAAA;AAyJJ;AAvJI;EACE,+BAAA;AAyJN;AArJE;EACE,oBAAA;EACA,WAAA;AAuJJ;AArJI;EACE,iBAAA;AAuJN;AApJI;EACE,UAAA;AAsJN;AAnJI;EACE,kBAAA;AAqJN;AAlJI;EACE,4BAAA;AAoJN;AAjJI;EACE,mCAAA;AAmJN;AAhJI;EACE,mCAAA;AAkJN;AA/II;EACE,8BAAA;AAiJN;AA9II;EACE,mBAAA;EACA,mBAAA;AAgJN;AA9IM;EACE,mBAAA;AAgJR;AA1IM;EACE,WAAA;EACA,WAAA;EACA,kCD3rCQ;EC4rCR,WAAA;EACA,kBAAA;EACA,aAAA;AA4IR;AAvIQ;EACE,kCDnsCK;ECosCL,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;AAyIV;;AA9HI;EACE,cAzuCM;EA0uCN,wBDtuCK;ECuuCL,yBAruCI;AAs2CV;AA9HQ;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAgIV;AA9HU;EANF;IAQI,eAAA;EAgIV;AACF;AA5HU;EACE,eAAA;EACA,+BA5vCD;EA6vCC,gBAAA;AA8HZ;AA5HY;EALF;IAOI,eAAA;EA8HZ;AACF;AA5HY;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AA8Hd;AA5Hc;EARF;IAUI,eAAA;EA8Hd;AACF;AA1HU;EA1BF;IA2BI,QAAA;EA6HV;AACF;AA1HQ;EA5CF;IA6CI,QAAA;EA6HR;AACF;AA1HM;EACE,eAAA;EACA,gBAAA;EACA,cA1xCG;EA2xCH,wBDjyCG;ECkyCH,yBA3xCK;AAu5Cb;AA1HQ;EAPF;IASI,eAAA;EA4HR;AACF;AAxHI;EACE,yBAzyCI;EA0yCJ,wBD1yCK;ACo6CX;AAtHU;EACE,eAAA;AAwHZ;AAtHY;EAHF;IAKI,eAAA;EAwHZ;AACF;AAtHY;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,yBA1zCJ;AAk7CV;AArHY;EACE,eAAA;EACA,cA/zCJ;AAs7CV;AAlHY;EACE,eAAA;AAoHd;AAlHc;EAHF;IAKI,eAAA;EAoHd;AACF;AAlHc;EACE,OAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAt1CN;AA08CV;AAjHc;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,wBDh2CL;ACm9CX;AAjHgB;EANF;IAQI,eAAA;EAmHhB;AACF;AA1Gc;;EACE,aAAA;AA6GhB;AAvGY;EACE,cAj3CJ;AA09CV;AApGQ;EACE,eAAA;EACA,wBD73CC;ACm+CX;AApGU;EAJF;IAMI,eAAA;EAsGV;AACF;AApGU;EACE,eAAA;EACA,4BDp4CD;AC0+CX;AApGY;EAJF;IAMI,eAAA;EAsGZ;AACF;AAjGU;EACE,cA54CF;EA64CE,eAAA;EACA,wBDh5CD;ACm/CX;AAjGY;EALF;IAOI,eAAA;EAmGZ;AACF;AAjGY;EACE,eAAA;AAmGd;AAjGc;EAHF;IAKI,eAAA;EAmGd;AACF;AA9FQ;EACE,SAAA;EACA,yBAp6CA;EAq6CA,eAAA;EACA,iBAAA;EACA,wBD16CC;AC0gDX;AA9FU;EAPF;IAQI,kBAAA;EAiGV;AACF;AA/FU;EACE,yBA96CF;AA+gDV;AA3FY;EACE,eAAA;EACA,wBDz7CH;ACshDX;AA3Fc;EACE,kBAAA;AA6FhB;AA3FgB;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,oCAn8CR;AAgiDV;AA1FgB;EACE,wBD18CP;ACsiDX;AA1FkB;EACE,SAAA;EACA,cAAA;EACA,cA18CV;EA28CU,wBD78CT;ACyiDX;AAtFgB;EACE,cAl9CR;EAm9CQ,wBDr9CP;AC6iDX;AAhFkB;EACE,UAAA;EACA,WAAA;AAkFpB;AAzEkB;EACE,yBAv+CV;AAkjDV;AAlEkB;EACE,aAAA;AAoEpB;AA7Dc;EACE,cAz/CN;EA0/CM,wBD5/CL;AC2jDX;AA7DgB;EACE,kBAAA;AA+DlB;AA7DkB;EACE,SAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAtgDV;AAqkDV;AA7DoB;EATF;IAUI,UAAA;EAgEpB;AACF;AAzDc;EACE,eAAA;EACA,wBDrhDL;ACglDX;AAzDgB;EACE,kBAAA;AA2DlB;AAzDkB;EAHF;IAII,kBAAA;EA4DlB;AACF;AA1DkB;EACE,eAAA;EACA,cAAA;EACA,wBDpiDT;ACgmDX;AA1DoB;EACE,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,cA9iDV;EA+iDU,kBAAA;EACA,kBAAA;EACA,wBD7iDX;EC8iDW,yBA5iDZ;AAwmDV;AA1DsB;EAbF;IAcI,MAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;EA6DtB;AACF;AAxDoB;EACE,oBAAA;EACA,gCAAA;AA0DtB;AAxDsB;EAJF;IAKI,eAAA;IACA,oBAAA;EA2DtB;AACF;AAtDgB;EApDF;IAsDI,eAAA;EAwDhB;AACF;AAjDU;EACE,cAAA;EACA,cAjlDF;EAklDE,eAAA;EACA,mBAAA;EACA,wBDtlDD;ECulDC,gCAAA;AAmDZ;AAjDY;EACE,iBAAA;AAmDd;AAhDY;EAZF;IAaI,eAAA;EAmDZ;AACF;AA9CU;EACE,cAAA;AAgDZ;AA9CY;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,wBD9mDH;EC+mDG,yBAAA;EACA,yBAAA;AAgDd;AA9Cc;;EAEE,kBAAA;EACA,kBAAA;EACA,yBAAA;AAgDhB;AA9CgB;;EACE,QAAA;EACA,SAAA;EACA,cAtnDR;EAunDQ,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBD5nDP;AC6qDX;AAzCU;EACE,mBAAA;EACA,yBAAA;AA2CZ;AAzCY;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAjpDF;EAkpDE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBA/oDJ;AA0rDV;AAzCc;EACE,kBAAA;AA2ChB;AAzCgB;EACE,YAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cA7pDD;EA8pDC,2BAAA;AA2ClB;AAzCkB;EATF;IAUI,YAAA;EA4ClB;AACF;AAzCgB;EAjBF;IAkBI,kBAAA;EA4ChB;AACF;AAzCc;EAjCF;IAkCI,WAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;EA4Cd;AACF;AAzCY;EA7CF;IA8CI,iBAAA;EA4CZ;AACF;AAvCY;EAFF;IAGI,eAAA;EA0CZ;AACF;AAxCY;EANF;IAOI,eAAA;EA2CZ;AACF;AAtCU;EACE,eAAA;EACA,wBDrsDD;AC6uDX;AAtCY;EACE,kBAAA;AAwCd;AAtCc;EACE,cAAA;EACA,eAAA;EACA,wBDhtDL;ACwvDX;AArCc;EATF;IAUI,kBAAA;EAwCd;AACF;AArCY;EAlBF;IAoBI,eAAA;EAuCZ;AACF;AAlCM;EACE,MAAA;EACA,WAAA;AAoCR;AAlCQ;EACE,kBAAA;EACA,kBAAA;EACA,cAruDO;EAsuDP,yBAAA;AAoCV;AAlCU;EACE,cAtuDF;AA0wDV;AAhCQ;EAfF;IAgBI,MAAA;IACA,QAAA;IACA,kBAAA;EAmCR;AACF;AA9BM;EACE,yBAhvDE;AAgxDV;AA9BQ;EACE,6BAlvDC;EAmvDD,yBAlvDG;AAkxDb;AAxBc;EACE,yBA7vDN;AAuxDV;AAvBc;EACE,cAjwDN;AA0xDV;AApBc;EACE,cAvwDN;AA6xDV;AAhBY;EACE,cA9wDJ;AAgyDV;AAToB;EACE,cAxxDZ;AAmyDV;AALkB;EACE,cA/xDV;AAsyDV;AACoB;EACE,yBAxyDZ;AAyyDV;AAMgB;EACE,cAhzDR;AA4yDV;AAOoB;EACE,yBApzDZ;AA+yDV;AAesB;EACE,yBA/zDd;AAkzDV;AAuBY;EACE,cA10DJ;EA20DI,gCAAA;AArBd;AA2Bc;EACE,yBAAA;AAzBhB;AA2BgB;;EAEE,yBAAA;AAzBlB;AA2BkB;;EACE,cAz1DV;AAi0DV;AAiCc;EACE,yBAn2DN;AAo0DV;AAuCY;EACE,cA52DJ;AAu0DV;AA6CM;EACE,yBAj3DE;AAs0DV;AA6CQ;EACE,cAn3DC;EAo3DD,yBAn3DG;AAw0Db;AA+CM;EACE,yBAp4DE;EAq4DF,wBDr4DG;ACw1DX;AAkDc;EACE,yBAj4DN;AAi1DV;AAmDc;EACE,cAr4DN;AAo1DV;AAsDc;EACE,cA34DN;AAu1DV;AA0DY;EACE,cAl5DJ;AA01DV;AAiEoB;EACE,cA55DZ;AA61DV;AAqEkB;EACE,cAn6DV;AAg2DV;AA2EoB;EACE,yBA56DZ;AAm2DV;AAgFgB;EACE,cAp7DR;AAs2DV;AAiFoB;EACE,yBAx7DZ;AAy2DV;AAyFsB;EACE,yBAn8Dd;AA42DV;AAiGY;EACE,cA98DJ;EA+8DI,gCAAA;AA/Fd;AAqGc;EACE,yBAAA;AAnGhB;AAqGgB;;EAEE,yBAAA;AAnGlB;AAqGkB;;EACE,cA79DV;AA23DV;AA2Gc;EACE,yBAv+DN;AA83DV;AAiHY;EACE,cAh/DJ;AAi4DV;AAuHM;EACE,yBAr/DE;AAg4DV;AAuHQ;EACE,cAx/DA;EAy/DA,yBAx/DG;AAm4Db;AA6Hc;EACE,yBAlgEN;AAu4DV;AA8Hc;EACE,cAtgEN;AA04DV;AAiIc;EACE,cA5gEN;AA64DV;AAqIY;EACE,cAnhEJ;AAg5DV;AA4IoB;EACE,cA7hEZ;AAm5DV;AAgJkB;EACE,cApiEV;AAs5DV;AAsJoB;EACE,yBA7iEZ;AAy5DV;AA2JgB;EACE,cArjER;AA45DV;AA4JoB;EACE,yBAzjEZ;AA+5DV;AAoKsB;EACE,yBApkEd;AAk6DV;AA4KY;EACE,cA/kEJ;EAglEI,gCAAA;AA1Kd;AAgLc;EACE,yBAAA;AA9KhB;AAgLgB;;EAEE,yBAAA;AA9KlB;AAgLkB;;EACE,cA9lEV;AAi7DV;AAsLc;EACE,yBAxmEN;AAo7DV;AA4LY;EACE,cAjnEJ;AAu7DV;;AAoME;EACE,oBAAA;AAjMJ;AAmMI;EAHF;IAIG,6BAAA;EAhMH;AACF;AAkMI;EAEE,oBAAA;EACA,kBAAA;AAjMN;AAqMM;EADF;IAEI,8BAAA;EAlMN;AACF;AAsMM;EADF;IAEI,6BAAA;EAnMN;EAqMM;IACE,kBAAA;EAnMR;AACF;;AAyMA;EAEE,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cDhpEmB;ECipEnB,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AAvMF;AAyME;EACE,sBDhpEgB;ECipEhB,kBDjpEgB;AC08DpB;AA0ME;EAjBF;IAkBI,gBAAA;EAvMF;AACF;;AA8ME;EACE,8BAAA;AA3MJ;AA6MI;EAHF;IAII,8BAAA;EA1MJ;AACF;AA6MM;EADF;IAEI,8BAAA;EA1MN;AACF;AA8MM;EADF;IAEI,6BAAA;EA3MN;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../assets/styles/variables';\n\n$crd-white: #FFFFFF;\n$crd-nmbr: #FFFFFF66;\n$crd-brdr--light: #E7E7E8;\n$crd-brdr--dark: #8A8A8A;\n$crd-txt: #000000CC;\n\n$cl-dark: #06A6CE;\n$cl-light: #1DA6CE;\n$cl-lighter: #E2F3F9;\n\n$id-dark: #FC8302;\n$id-light: #FC8302CC;\n$id-lighter: #FFEFE1;\n\n$dv-dark: #7BBC43;\n$dv-light: #64BD47;\n$dv-lighter: #ECF5E8;\n\n$im-dark: #FC485C;\n$im-lighter: #FDE9E5;\n\n/*Media Query*/\n\n@mixin screen ($point) {\n  @if $point==iphone {\n    @media (max-width: 500px) {\n      @content ;\n    }\n  }\n}\n\n::ng-deep .all-toolcards {\n  .innovation-section.toolcards {\n    max-width: 740px;\n    margin: 20px auto 30px;\n\n    @include screen (iphone) {\n      min-height: 0;\n    }\n\n    width: 100%;\n\n    p {\n      font-family: $muso-300;\n      font-size: 15px;\n\n      @include screen (iphone) {\n        font-size: 12px;\n        line-height: 20px;\n      }\n\n      b {\n        font-family: $muso-700;\n      }\n    }\n\n    ul {\n      font-size: 15px;\n      line-height: 24px;\n      font-family: $muso-300;\n\n      @include screen (iphone) {\n        font-size: 12px;\n        line-height: 20px;\n      }\n    }\n\n    small {\n      font-size: 75%;\n\n      @include screen (iphone) {\n        font-size: 90%;\n      }\n    }\n\n    blockquote {\n      border: none;\n      margin: 0px;\n      font-size: 15px;\n      padding: 10px 12px;\n\n      @include screen (iphone) {\n        font-size: 12px;\n      }\n    }\n  }\n\n  section#mind-mapping .inside img {\n    margin-top: 35px;\n  }\n\n  .toolcards {\n    &.innovation-section {\n      position: relative;\n\n      .section-top {\n        padding: 45px 60px 0px;\n\n        @include screen (iphone) {\n          padding: 30px 15px 0;\n        }\n      }\n\n      .top-heading {\n        font-size: 23px;\n\n        @include screen (iphone) {\n          font-size: 20px;\n          line-height: 30px;\n        }\n\n        span {\n          font-size: 20px;\n          display: block;\n          margin: 0px;\n          line-height: 16px;\n\n          @include screen (iphone) {\n            font-size: 18px;\n          }\n        }\n      }\n\n      .sub-heading {\n        font-size: 20px;\n\n        @include screen (iphone) {\n          font-size: 17px;\n\n          br {\n            display: none;\n          }\n        }\n      }\n\n      .right-heading {\n        text-align: right;\n        margin: 0px;\n        font-size: 70px;\n        color: $color-light-type;\n        letter-spacing: 4px;\n        font-family: $muso-700;\n        opacity: 0.4;\n\n        @include screen (iphone) {\n          font-size: 45px;\n        }\n\n        span {\n          font-size: 12px;\n          text-transform: uppercase;\n\n          @include screen (iphone) {\n            font-size: 10px;\n          }\n        }\n      }\n\n      input.input-text {\n        border: none;\n        width: 100%;\n        outline: none;\n        font-size: 16px;\n        text-indent: 10px;\n      }\n\n      .cards-content {\n        padding: 40px 60px;\n\n        @include screen (iphone) {\n          padding: 20px 15px;\n\n          .col-xs-6,\n          .col-xs-5,\n          .col-xs-4,\n          .col-xs-3,\n          .col-xs-2,\n          .col-xs-8,\n          .col-xs-9,\n          .col-xs-7 {\n            width: 100%;\n          }\n\n          .col-xs-offset-6 {\n            display: none;\n          }\n        }\n\n        img {\n          display: block;\n          margin: 0 auto;\n          max-width: 100%;\n        }\n\n        .pcq {\n          border-bottom: 2px solid $clarify-color;\n          margin: 0 0 15px;\n\n          .col-xs-6 {\n            padding: 0px;\n          }\n        }\n\n        .inside {\n          img {\n            margin-bottom: 10px;\n            width: 100%;\n\n            @include screen (iphone) {\n              display: inherit;\n              margin: 15px auto;\n              width: auto;\n            }\n          }\n\n          p {\n            margin-bottom: 8px !important;\n          }\n\n          table {\n            width: 100%;\n            border: 2px solid $develop-color;\n            margin: 25px 0px;\n            table-layout: fixed;\n\n            th {\n              color: $develop-color;\n            }\n\n            th,\n            td {\n              width: 25%;\n              border: 1px solid $develop-color;\n              text-align: center;\n              font-size: 16px;\n              height: 35px;\n\n              @include screen (iphone) {\n                font-size: 14px;\n              }\n            }\n\n            td:first-child {\n              font-size: 12px;\n\n              @include screen (iphone) {\n                font-size: 10px;\n              }\n            }\n\n            &.t-table {\n              border: 0;\n\n              th,\n              td {\n                border: 0;\n              }\n\n              th {\n                border-bottom: 2px solid $develop-color;\n\n                &:first-child {\n                  border-right: 2px solid $develop-color;\n                }\n              }\n\n              td {\n                border-bottom: 1px solid $develop-color;\n\n                &:first-child {\n                  border-right: 2px solid $develop-color;\n                }\n              }\n            }\n\n            &.t-risk {\n              margin-bottom: 60px;\n              margin-top: 50px;\n\n              td {\n                vertical-align: top;\n                text-align: left;\n              }\n\n              ul {\n                padding: 0px 0 0 10px;\n                margin: 0px;\n                list-style-type: none;\n\n                li {\n                  margin-bottom: 10px;\n                  font-size: 14px;\n\n                  @include screen (iphone) {\n                    font-size: 12px;\n                  }\n                }\n              }\n            }\n\n            &.t-assist {\n              border: 0;\n\n              th,\n              td {\n                border: 0;\n              }\n\n              th {\n                font-size: 18px;\n                border-bottom: 2px solid $implement-color;\n                color: $implement-color;\n\n                &:first-child {\n                  border-right: 2px solid $implement-color;\n                }\n\n                @include screen (iphone) {\n                  font-size: 16px;\n                }\n              }\n\n              td {\n                &:first-child {\n                  border-right: 2px solid $implement-color\n                }\n              }\n\n              textarea {\n                width: 100%;\n                margin: 0px;\n                height: 100%;\n                background: $color-light-type;\n                outline: none;\n                min-height: 400px;\n                resize: none;\n                border: none;\n                font-size: 15px;\n              }\n            }\n\n            &.t-action {\n              border: 2px solid $implement-color;\n\n              th,\n              td {\n                border: 0;\n              }\n\n              textarea {\n                width: 100%;\n                margin: 0px;\n                height: 100%;\n                background: $color-light-type;\n                outline: none;\n                min-height: 180px;\n                resize: none;\n                border: none;\n                font-size: 15px;\n              }\n\n              th {\n                background: $implement-color;\n                color: $color-light-type;\n              }\n\n              td {\n                border-right: 1px dashed $implement-color;\n                color: $implement-color;\n                height: 160px;\n                vertical-align: top;\n                text-align: left;\n                padding: 10px;\n              }\n            }\n\n            &.brain-table {\n              tr td {\n                height: 200px;\n                /* Safari/Chrome, other WebKit */\n                /* Firefox, other Gecko */\n                box-sizing: border-box;\n                /* Opera/IE 8+ */\n                border: 5px solid #000000;\n                // border-image: url($assets+'/images/ac150.png') 34% repeat;\n              }\n            }\n          }\n        }\n\n        ul {\n          padding-left: 15px;\n        }\n\n        .page-footer {\n          font-size: 10px !important;\n          position: absolute;\n          bottom: 10px;\n          margin: 0px;\n\n          a {\n            font-family: $muso-700;\n            color: #8a8a8a;\n          }\n\n          @include screen (iphone) {\n            position: relative;\n            bottom: 0;\n          }\n        }\n\n        .bg-heading {\n          margin: 0px;\n          padding: 20px 0px 40px 20px;\n          line-height: 25px;\n          background: url($assets+'/images/toolcards/icon-bg.png') no-repeat;\n          background-size: contain;\n          font-size: 20px;\n        }\n      }\n\n      p.clr-text {\n        font-size: 23px;\n        font-family: $muso-100;\n        line-height: 29px;\n\n        @include screen (iphone) {\n          font-size: 16px;\n          line-height: 24px;\n        }\n      }\n\n      .clr-num {\n        display: inline-block;\n        font-size: 20px;\n        font-family: $muso-700;\n        float: left;\n      }\n\n      .b-box-inside {\n        overflow: hidden;\n      }\n\n      .b-box {\n        width: 32%;\n        margin: 10px .5%;\n        float: left;\n        height: 250px;\n        box-sizing: border-box;\n        background: transparent;\n        background-size: contain;\n        position: relative;\n\n        &.left-border {\n          background: url($assets+\"/images/toolcards/right2.png\") no-repeat !important;\n          background-position: top left !important;\n          background-size: contain !important;\n        }\n\n        &.right-border {\n          background: url($assets+\"/images/toolcards/left2.png\") no-repeat !important;\n          background-position: top right !important;\n          background-size: contain !important;\n        }\n\n        .icon {\n          font-size: 50px;\n          position: absolute;\n          top: 50%;\n          text-align: center;\n          margin-top: -30px;\n          left: 0;\n          right: 0;\n        }\n      }\n\n      .idea {\n        padding: 20px 0px;\n        margin-bottom: 75px;\n\n        .right img {\n          width: 100px;\n          margin-top: 50px;\n        }\n\n        img {\n          width: 130px;\n          margin-bottom: 15px;\n        }\n\n        .bottom-img {\n          img {\n            margin-top: 30px;\n            display: inline-block;\n          }\n\n          @include screen (iphone) {\n            text-align: center;\n          }\n        }\n      }\n\n      .story-board-content {\n        @include screen (iphone) {\n          max-width: 70%;\n          margin: 0px auto;\n        }\n\n        img {\n          min-height: 120px;\n        }\n\n        overflow: hidden;\n        text-align: center;\n\n        p {\n          line-height: 16px;\n        }\n\n        figcaption {\n          min-height: 90px;\n        }\n      }\n\n      .line-border {\n        border-bottom: 2px solid;\n        padding-bottom: 5px;\n\n        &--mb {\n          margin-bottom: 10px;\n        }\n      }\n\n      .alpha-content {\n        margin: 0 0 15px;\n        position: relative;\n        overflow: hidden;\n\n        span {\n          display: inline-block;\n          float: left;\n          font-size: 30px;\n          line-height: 40px;\n          width: 44px;\n          height: 40px;\n          border-radius: 50%;\n          color: $color-light-type;\n          text-align: center;\n          margin: 0 15px 30px 0;\n        }\n\n        p {\n          margin: 0px;\n          line-height: 16px;\n        }\n\n        &.point {\n          margin-bottom: 30px;\n\n          span {\n            float: none;\n            margin: 0px;\n          }\n\n          .fa {\n            font-size: 20px;\n            line-height: 40px;\n            margin: 0px 10px;\n            color: $develop-color;\n            font-weight: 100;\n          }\n        }\n      }\n\n      .right {\n        .alpha-icon {\n          width: 100px;\n          margin-top: 20px !important;\n          ;\n        }\n      }\n\n      .alpha-icon {\n        width: 70px;\n        display: inline-block !important;\n        margin: 0 0 15px !important;\n      }\n\n      .point-icons {\n        margin-top: 90px;\n      }\n\n      &.clarify {\n        .section-top {\n          background: $clarify-color;\n        }\n\n        p.clr-text {\n          color: $clarify-color;\n        }\n\n        .clr-num {\n          color: $clarify-color;\n        }\n\n        .bg-heading {\n          color: $clarify-color;\n          font-family: $muso-700;\n        }\n\n        .phrase {\n          float: left;\n          margin-right: 30px;\n        }\n\n        .p1 {\n          background: url($assets+'/images/toolcards/p1-bg.png') no-repeat;\n          background-size: 100% 100%;\n          padding: 15px 10px 35px 10px;\n        }\n\n        .p2 {\n          background: url($assets+'/images/toolcards/p2-bg.png') no-repeat;\n          background-size: 100% 100%;\n          padding: 15px 10px 35px 10px;\n        }\n\n        .p3 {\n          background: url($assets+'/images/toolcards/p3-bg.png') no-repeat;\n          background-size: 100% 100%;\n          padding: 15px 10px 35px 10px;\n        }\n\n        .p4 {\n          background: url($assets+'/images/toolcards/p4-bg.png') no-repeat;\n          background-size: 100% 100%;\n          padding: 15px 10px 35px 10px;\n        }\n\n        blockquote {\n          color: $clarify-color;\n        }\n\n        .cards-content {\n          span {\n            color: $clarify-color;\n            font-family: $muso-700;\n          }\n        }\n\n        .bug img {\n          width: 55px;\n          margin: 0 15px 10px 0px !important;\n        }\n      }\n\n      /* some-specific-style*/\n      &.ideate {\n        .section-top {\n          background: $ideate-color !important;\n        }\n\n        p.clr-text {\n          color: $ideate-color;\n        }\n\n        .clr-num {\n          color: $ideate-color;\n        }\n\n        .bg-heading {\n          color: $ideate-color;\n          font-family: $muso-700;\n        }\n\n        blockquote {\n          color: $ideate-color;\n        }\n\n        .bg-heading {\n          background: url($assets+'/images/toolcards/2a-bg.png') no-repeat;\n          background-size: contain;\n          padding: 15px 0 48px 20px;\n        }\n\n        .alpha-content {\n          span {\n            background: $ideate-color;\n            color: $color-light-type !important;\n          }\n        }\n\n        .cards-content {\n          span {\n            color: $ideate-color;\n            font-family: $muso-700;\n          }\n        }\n      }\n\n      &.develop {\n        .section-top {\n          background: $develop-color;\n        }\n\n        p.clr-text {\n          color: $develop-color;\n        }\n\n        .clr-num {\n          color: $develop-color;\n        }\n\n        .bg-heading {\n          color: $develop-color;\n          font-family: $muso-700;\n        }\n\n        blockquote {\n          color: $develop-color;\n        }\n\n        .alpha-content {\n          span {\n            background: $develop-color;\n            color: $color-light-type !important;\n          }\n\n          b {\n            color: $develop-color\n          }\n        }\n\n        .cards-content {\n          span {\n            color: $develop-color;\n            font-family: $muso-700;\n          }\n        }\n\n        .target {\n          overflow: hidden;\n          margin-bottom: 30px;\n\n          .col-xs-6 {\n            padding: 0px;\n          }\n\n          p {\n            border-bottom: 2px solid $develop-color;\n            font-size: 14px;\n            line-height: 24px;\n          }\n        }\n      }\n\n      &.implement {\n        .section-top {\n          background: $implement-color;\n        }\n\n        p.clr-text {\n          color: $implement-color;\n        }\n\n        .clr-num {\n          color: $implement-color;\n        }\n\n        .bg-heading {\n          color: $implement-color;\n          font-family: $muso-700;\n        }\n\n        blockquote {\n          color: $implement-color;\n        }\n\n        .alpha-content span {\n          background: $implement-color;\n        }\n\n        .cards-content {\n          span {\n            color: $implement-color;\n            font-family: $muso-700;\n          }\n        }\n\n        .thumb-img {\n          max-width: 160px;\n          margin-top: 50px;\n        }\n\n        .stake-img {\n          max-width: 120px;\n        }\n\n        .time-img {\n          max-width: 90px;\n        }\n\n        .action {\n          margin-top: 50px;\n        }\n\n        .perform {\n          margin: 20px 0px 30px;\n        }\n\n        .dash-icons {\n          margin: 30px 0px;\n\n          .row {\n            margin: 15px 0px;\n          }\n\n          p {\n            margin-top: 10px;\n          }\n        }\n\n        .learn {\n          margin: 30px 0px;\n        }\n      }\n\n      &.gray {\n        .section-top {\n          background: $color-light-type;\n          ;\n        }\n\n        .top-heading {\n          color: #8a8a8a;\n          font-family: $muso-700;\n          font-size: 30px;\n        }\n\n        .cards-content {\n          padding-top: 20px;\n        }\n\n        .page-footer {\n          position: static;\n          margin-top: 25px;\n        }\n\n        .last-footer {\n          background: #6c6d70;\n          padding: 20px 30px;\n          border-top: 25px solid #e6e7e9;\n\n          img {\n            width: 200px;\n          }\n        }\n\n        .f-img {\n          width: 35px;\n        }\n      }\n\n      &.eos-level {\n        margin: 0 0 0 10px;\n        color: #333;\n\n        .top-heading {\n          color: #333;\n          font-size: 30px;\n          border: 2px solid;\n        }\n\n        .sub-heading {\n          font-family: $muso-700;\n          color: #333;\n        }\n\n        .row {\n          font-size: 16px;\n\n          input {\n            border: none;\n            outline: none;\n          }\n\n          &.top {\n            input {\n              border-bottom: 2px solid #333;\n            }\n          }\n        }\n\n        .bottom {\n          margin-top: 35px;\n\n          textarea {\n            width: 100%;\n            height: 100%;\n            min-height: 60px;\n            overflow: hidden;\n            resize: none;\n            background: $color-light-type;\n          }\n        }\n\n        .table-10 {\n          width: 100%;\n          max-width: 480px;\n          margin: 0px auto;\n          table-layout: auto;\n\n          td {\n            padding: 10px 0px;\n            vertical-align: top;\n          }\n        }\n      }\n    }\n  }\n\n  .story-board.row .custom {\n    min-height: 250px;\n  }\n\n  #last-page {\n    background: #6c6d70;\n\n    @include screen (iphone) {\n      min-height: 600px;\n    }\n\n    .page-footer {\n      margin: 0px auto;\n      left: 0;\n      right: 0;\n      position: absolute;\n\n      a {\n        color: $color-light-type;\n      }\n    }\n  }\n\n  section#storyboading .col-xs-4.padding {\n    @include screen (iphone) {\n      width: 33% !important;\n    }\n  }\n\n  section#forced-connections .bg-heading {\n    @include screen (iphone) {\n      font-size: 17px;\n      line-height: 1.1;\n\n      body.body-small & {\n        padding-right: 24%;\n      }\n\n      body.body-small.mini-navbar & {\n        padding-right: 0%;\n      }\n    }\n\n    @media only screen and (max-width:413px) {\n      body.body-small & {\n        padding-right: 13%;\n      }\n    }\n  }\n\n  #first-page {\n    background: url($assets+'/images/toolcards/home-1.png') no-repeat;\n    background-size: cover;\n\n    @include screen (iphone) {\n      min-height: 600px;\n    }\n\n    .four-tool {\n      position: absolute;\n      bottom: 25px;\n      left: 0;\n      width: 100%;\n\n      .main-heading {\n        color: $color-light-type;\n        font-size: 45px;\n        line-height: 48px;\n        font-family: $muso-700;\n        margin: 0px;\n        padding-left: 30px;\n\n        @include screen (iphone) {\n          font-size: 30px;\n          line-height: 40px;\n        }\n      }\n\n      .top-heading {\n        color: $color-light-type;\n        line-height: 30px;\n        padding-left: 30px;\n      }\n\n      .cards-footer {\n        background: #6c6d70;\n        padding: 20px 30px;\n        border-top: 25px solid #e6e7e9;\n        margin-top: 25px;\n\n        p {\n          color: $color-light-type;\n          margin: 0px;\n          padding-top: 10px;\n\n          @include screen (iphone) {\n            text-align: center;\n          }\n        }\n\n        img {\n          width: 200px;\n        }\n      }\n    }\n  }\n\n  #tools-mind {\n    padding-top: 140px;\n    background: url($assets+'/images/toolcards/bulb.png') no-repeat;\n    background-size: 70%;\n    background-color: #e6e7e9;\n    background-position: center top;\n\n    .top-heading {\n      line-height: 36px;\n    }\n\n    p a {\n      color: inherit;\n    }\n  }\n\n  .print-logo {\n    display: none;\n    position: absolute;\n    right: 40px;\n    top: 0px;\n  }\n\n  #tools-index {\n    background-color: #e6e7e9;\n\n    .section-top {\n      background-color: #6c6d70;\n      color: $color-light-type;\n      padding: 30px 60px 0px;\n\n      @media(max-width: 767px) {\n        padding: 15px 60px;\n      }\n\n      .top-heading {\n        font-size: 30px;\n        text-align: center;\n      }\n    }\n\n    .cards-content {\n      padding: 20px 35px;\n\n      @media #{$mobile} {\n        padding: 15px;\n      }\n\n      .col-xs-6 {\n        padding: 20px;\n      }\n\n      .clarify {\n        background-color: $clarify-color;\n      }\n\n      .ideate {\n        background: $ideate-color;\n      }\n\n      .develop {\n        background: $develop-color;\n      }\n\n      .implement {\n        background: $implement-color;\n      }\n\n      .sub-heading {\n        color: $color-light-type;\n      }\n\n      p {\n        span {\n          color: $color-light-type;\n        }\n\n        a {\n          color: $color-light-type;\n          display: inline-block;\n          padding-left: 5px;\n        }\n      }\n    }\n  }\n}\n\n@media print {\n\n  ::ng-deep .all-toolcards {\n    .innovation-section {\n      .section-top {\n\n        .top-heading,\n        span {\n          color: $color-light-type !important;\n        }\n\n        .right-heading,\n        span {\n          color: $color-light-type !important;\n\n        }\n      }\n\n      .cards-content {\n        padding-top: 10px !important;\n      }\n    }\n\n    .toolcards.innovation-section.ideate {\n\n      p.clr-text,\n      .sub-heading {\n        color: $ideate-color !important;\n      }\n    }\n\n    a.print-button {\n      display: none;\n    }\n\n    input {\n      color: $ideate-color !important;\n    }\n  }\n\n}\n\n::ng-deep .tdq {\n  --bg-clr: #E2F3F9;\n  --p-clr: #000000CC;\n  --id-clr: #FFEFE1;\n  flex-wrap: nowrap;\n\n  &__head {\n\n    h1 {\n\n      span {\n        top: -5px;\n        left: 30px;\n        text-transform: none;\n      }\n    }\n  }\n\n  &__fr {\n    padding: 23px;\n    font-size: 24px;\n    background-color: var(--bg-clr);\n\n    &--clrid {\n      background-color: var(--id-clr);\n    }\n  }\n\n  &__body {\n    padding: 0 10px 50px;\n    width: 100%;\n\n    &--pdn {\n      padding-bottom: 0;\n    }\n\n    &--wd {\n      width: 50%;\n    }\n\n    &-negml {\n      margin-left: -10px;\n    }\n\n    &--ml {\n      margin-left: 50px !important;\n    }\n\n    &--ff3 {\n      font-family: $muso-300 !important;\n    }\n\n    &--ff7 {\n      font-family: $muso-700 !important;\n    }\n\n    &--clrb {\n      color: var(--p-clr) !important;\n    }\n\n    p {\n      color: var(--p-clr);\n      padding-bottom: 5px;\n\n      b {\n        color: var(--p-clr);\n      }\n    }\n\n    .sub-heading {\n\n      &::before {\n        content: '';\n        width: 30px;\n        background-color: $clarify-color;\n        height: 5px;\n        position: absolute;\n        bottom: -10px;\n      }\n\n      &--clrid {\n\n        &::before {\n          background-color: $ideate-color;\n          content: '';\n          width: 30px;\n          height: 5px;\n          position: absolute;\n          bottom: -10px;\n        }\n      }\n    }\n  }\n}\n\n// 04-01\n\n::ng-deep .tlcrd {\n  &__typ {\n    .tlcrd-hdr {\n      color: $crd-white;\n      font-family: $muso-700;\n      background-color: $cl-dark;\n\n      &__cntnt {\n        h2 {\n          margin-top: 0;\n          font-size: 30px;\n          line-height: 1.5;\n          text-transform: capitalize;\n\n          @media (min-width:992px) and (max-width:1199px),\n          (max-width: 767px) {\n            font-size: 24px;\n          }\n        }\n\n        &--rght {\n          h1 {\n            font-size: 65px;\n            color: $crd-nmbr;\n            margin-top: 10px;\n\n            @media (min-width:992px) and (max-width:1199px),\n            (max-width: 767px) {\n              font-size: 50px;\n            }\n\n            .typ {\n              left: 50%;\n              top: -15px;\n              width: 100%;\n              font-size: 15px;\n              line-height: 27px;\n              transform: translateX(-50%);\n\n              @media (min-width:992px) and (max-width:1199px),\n              (max-width: 767px) {\n                font-size: 12px;\n              }\n            }\n          }\n\n          @media #{$mobile} {\n            order: 1;\n          }\n        }\n\n        @media #{$mobile} {\n          order: 2;\n        }\n      }\n\n      &--btm {\n        font-size: 20px;\n        line-height: 1.2;\n        color: $cl-light;\n        font-family: $muso-300;\n        background-color: $cl-lighter;\n\n        @media (min-width:992px) and (max-width:1199px),\n        (max-width: 767px) {\n          font-size: 16px;\n        }\n      }\n    }\n\n    .tlcrd-body {\n      color: $crd-txt;\n      font-family: $muso-700;\n\n      &__blk {\n        .tlcrd-body__hdng {\n          h3 {\n            font-size: 22px;\n\n            @media (min-width:992px) and (max-width:1199px),\n            (max-width: 767px) {\n              font-size: 18px;\n            }\n\n            &:before {\n              content: '';\n              width: 30px;\n              height: 4px;\n              bottom: -15px;\n              position: absolute;\n              background-color: $cl-dark;\n            }\n\n            span {\n              font-size: 17px;\n              color: $cl-dark;\n            }\n          }\n\n          &--sml {\n            h4 {\n              font-size: 18px;\n\n              @media (min-width:992px) and (max-width:1199px),\n              (max-width: 767px) {\n                font-size: 16px;\n              }\n\n              &:before {\n                left: 0;\n                top: 4px;\n                width: 8px;\n                height: 8px;\n                content: '';\n                position: absolute;\n                border-radius: 50%;\n                background-color: $crd-txt;\n              }\n\n              span {\n                display: block;\n                font-size: 15px;\n                font-weight: 300;\n                font-family: $muso-300;\n\n                @media (min-width:992px) and (max-width:1199px),\n                (max-width: 767px) {\n                  font-size: 12px;\n                }\n              }\n            }\n          }\n\n          &--nostyl {\n\n            h3,\n            h4 {\n              &:before {\n                display: none;\n              }\n            }\n          }\n\n          &--clrd {\n            h3 {\n              color: $cl-dark;\n            }\n          }\n        }\n\n        .tlcrd-body__txt {\n          font-size: 18px;\n          font-family: $muso-300;\n\n          @media (min-width:992px) and (max-width:1199px),\n          (max-width: 767px) {\n            font-size: 16px;\n          }\n\n          &--bold {\n            font-size: 18px;\n            font-family: $muso-500;\n\n            @media (min-width:992px) and (max-width:1199px),\n            (max-width: 767px) {\n              font-size: 16px;\n            }\n          }\n        }\n\n        &--qt {\n          .tlcrd-body__qt {\n            color: $cl-dark;\n            font-size: 16px;\n            font-family: $muso-700;\n\n            @media (min-width:992px) and (max-width:1199px),\n            (max-width: 767px) {\n              font-size: 14px;\n            }\n\n            &--athr {\n              font-size: 14px;\n\n              @media (min-width:992px) and (max-width:1199px),\n              (max-width: 767px) {\n                font-size: 12px;\n              }\n            }\n          }\n        }\n\n        &--ftr {\n          bottom: 0;\n          color: $crd-txt;\n          font-size: 10px;\n          line-height: 17px;\n          font-family: $muso-300;\n\n          @media #{$pc} {\n            position: relative;\n          }\n\n          a {\n            color: $crd-txt;\n          }\n        }\n\n        &--lst {\n          .tlcrd-body__lst {\n            ul {\n              font-size: 16px;\n              font-family: $muso-300;\n\n              li {\n                position: relative;\n\n                &:before {\n                  top: 8px;\n                  width: 8px;\n                  left: -18px;\n                  content: '';\n                  height: 8px;\n                  border-radius: 50%;\n                  position: absolute;\n                  background-color: $crd-txt;\n                }\n\n                span {\n                  font-family: $muso-300;\n\n                  &.clr {\n                    margin: 0;\n                    display: block;\n                    color: $cl-dark;\n                    font-family: $muso-700;\n                  }\n                }\n              }\n\n              &.clrd {\n                li {\n                  color: $cl-dark;\n                  font-family: $muso-700;\n                }\n              }\n            }\n\n            &--b-sml {\n              ul {\n                li {\n                  &:before {\n                    width: 5px;\n                    height: 5px;\n                  }\n                }\n              }\n            }\n\n            &--clrd {\n              ul {\n                li {\n                  &:before {\n                    background-color: $cl-dark;\n                  }\n                }\n              }\n            }\n\n            &--nostyl {\n              ul {\n                li {\n                  &:before {\n                    display: none;\n                  }\n                }\n              }\n            }\n\n            .blank {\n              ul {\n                color: $cl-dark;\n                font-family: $muso-700;\n\n                li {\n                  position: relative;\n\n                  &:after {\n                    bottom: 0;\n                    left: 85px;\n                    width: 70%;\n                    content: '';\n                    height: 2px;\n                    position: absolute;\n                    background-color: $cl-dark;\n\n                    @media #{$mobile} {\n                      width: 55%;\n                    }\n                  }\n                }\n              }\n            }\n\n            &--styled {\n              ul {\n                font-size: 20px;\n                font-family: $muso-700;\n\n                li {\n                  padding-left: 40px;\n\n                  @media #{$tablet} {\n                    padding-left: 20px;\n                  }\n\n                  span {\n                    font-size: 18px;\n                    display: block;\n                    font-family: $muso-300;\n\n                    &.cstmzd-blts {\n                      top: -10px;\n                      left: -25px;\n                      width: 50px;\n                      height: 50px;\n                      padding: 8px;\n                      font-size: 25px;\n                      color: $crd-white;\n                      border-radius: 50%;\n                      text-align: center;\n                      font-family: $muso-700;\n                      background-color: $cl-dark;\n\n                      @media #{$tablet} {\n                        top: 0;\n                        width: 28px;\n                        height: 28px;\n                        padding: 4px;\n                        font-size: 12px;\n                      }\n                    }\n                  }\n\n                  &:not(:last-child) {\n                    span {\n                      padding-bottom: 25px;\n                      border-bottom: 1px solid $crd-brdr--light;\n\n                      @media #{$tablet} {\n                        font-size: 14px;\n                        padding-bottom: 10px;\n                      }\n                    }\n                  }\n                }\n\n                @media (min-width:992px) and (max-width:1199px),\n                (max-width: 767px) {\n                  font-size: 16px;\n                }\n              }\n            }\n          }\n        }\n\n        &--arw {\n          span {\n            display: block;\n            color: $cl-dark;\n            font-size: 22px;\n            margin-bottom: 20px;\n            font-family: $muso-700;\n            border-bottom: 1px solid $cl-dark;\n\n            &:nth-child(2) {\n              padding-top: 20px;\n            }\n\n            @media #{$mobile} {\n              font-size: 18px;\n            }\n          }\n        }\n\n        &--tbl {\n          .tlcrd-body__tbl {\n            overflow: auto;\n\n            table {\n              width: 100%;\n              font-size: 16px;\n              line-height: 1.3;\n              font-family: $muso-300;\n              border-collapse: collapse;\n              border: 2px solid $cl-dark;\n\n              th,\n              td {\n                position: relative;\n                padding: 20px 15px;\n                border: 2px solid $cl-dark;\n\n                .row-info {\n                  top: 2px;\n                  left: 2px;\n                  color: $cl-dark;\n                  font-size: 22px;\n                  position: absolute;\n                  text-align: center;\n                  font-family: $muso-700;\n                }\n              }\n            }\n          }\n        }\n\n        &--pnts {\n          ul {\n            border-radius: 20px;\n            border: 9px solid $crd-brdr--light;\n\n            li {\n              width: 50px;\n              height: 50px;\n              padding: 8px;\n              font-size: 25px;\n              color: $crd-white;\n              border-radius: 50%;\n              text-align: center;\n              position: relative;\n              background-color: $cl-dark;\n\n              &:not(:last-child) {\n                margin-right: 50px;\n\n                &:after {\n                  content: \"+\";\n                  top: 50%;\n                  right: -31px;\n                  font-size: 20px;\n                  position: absolute;\n                  color: $crd-brdr--dark;\n                  transform: translateY(-50%);\n\n                  @media (max-width: 1440px) {\n                    right: -25px;\n                  }\n                }\n\n                @media (max-width: 1440px) {\n                  margin-right: 50px;\n                }\n              }\n\n              @media (max-width: 1440px) {\n                width: 28px;\n                height: 28px;\n                padding: 6px;\n                font-size: 12px;\n              }\n            }\n\n            @media (max-width: 1440px) {\n              border-width: 4px;\n            }\n          }\n\n          .tlcrd-body__txt {\n\n            @media (max-width: 1440px) {\n              font-size: 16px;\n            }\n\n            @media (max-width: 991px) {\n              font-size: 14px;\n            }\n          }\n        }\n\n        &--olst {\n          ol {\n            font-size: 20px;\n            font-family: $muso-700;\n\n            li {\n              padding-left: 15px;\n\n              span {\n                display: block;\n                font-size: 16px;\n                font-family: $muso-300;\n              }\n\n              @media #{$mobile} {\n                padding-left: 10px;\n              }\n            }\n\n            @media (min-width:992px) and (max-width:1199px),\n            (max-width: 767px) {\n              font-size: 16px;\n            }\n          }\n        }\n      }\n\n      .btn-grp {\n        top: 0;\n        right: 30px;\n\n        a {\n          padding: 10px 15px;\n          border-radius: 5px;\n          color: $crd-brdr--dark;\n          border: 1px solid $crd-brdr--dark;\n\n          i {\n            color: $cl-dark;\n          }\n        }\n\n        @media #{$mobile} {\n          top: 0;\n          right: 0;\n          position: relative;\n        }\n      }\n    }\n\n    &--id {\n      .tlcrd-hdr {\n        background-color: $id-dark;\n\n        &--btm {\n          color: $id-light;\n          background-color: $id-lighter;\n        }\n      }\n\n      .tlcrd-body {\n        &__blk {\n          .tlcrd-body__hdng {\n            h3 {\n              &:before {\n                background-color: $id-dark;\n              }\n\n              span {\n                color: $id-dark;\n              }\n            }\n\n            &--clrd {\n              h3 {\n                color: $id-dark;\n              }\n            }\n          }\n\n          &--qt {\n            .tlcrd-body__qt {\n              color: $id-dark;\n            }\n          }\n\n          &--lst {\n            .tlcrd-body__lst {\n              ul {\n                li {\n                  span {\n                    &.clr {\n                      color: $id-dark;\n                    }\n                  }\n                }\n\n                &.clrd {\n                  li {\n                    color: $id-dark;\n                  }\n                }\n              }\n\n              &--clrd {\n                ul {\n                  li {\n                    &:before {\n                      background-color: $id-dark;\n                    }\n                  }\n                }\n              }\n\n              .blank {\n                ul {\n                  color: $id-dark;\n\n                  li {\n                    &:after {\n                      background-color: $id-dark;\n                    }\n                  }\n                }\n              }\n\n              &--styled {\n                ul {\n                  li {\n                    span {\n                      &.cstmzd-blts {\n                        background-color: $id-dark;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          &--arw {\n            span {\n              color: $id-dark;\n              border-bottom: 1px solid $id-dark;\n            }\n          }\n\n          &--tbl {\n            .tlcrd-body__tbl {\n              table {\n                border: 2px solid $id-dark;\n\n                th,\n                td {\n                  border: 2px solid $id-dark;\n\n                  .row-info {\n                    color: $id-dark;\n                  }\n                }\n              }\n            }\n          }\n\n          &--pnts {\n            ul {\n              li {\n                background-color: $id-dark;\n              }\n            }\n          }\n        }\n\n        .btn-grp {\n          a {\n            i {\n              color: $id-dark;\n            }\n          }\n        }\n      }\n    }\n\n    &--dv {\n      .tlcrd-hdr {\n        background-color: $dv-dark;\n\n        &--btm {\n          color: $dv-light;\n          background-color: $dv-lighter;\n        }\n      }\n\n      .tlcrd-body {\n        color: $crd-txt;\n        font-family: $muso-700;\n\n        &__blk {\n          .tlcrd-body__hdng {\n            h3 {\n              &:before {\n                background-color: $dv-dark;\n              }\n\n              span {\n                color: $dv-dark;\n              }\n            }\n\n            &--clrd {\n              h3 {\n                color: $dv-dark;\n              }\n            }\n          }\n\n          &--qt {\n            .tlcrd-body__qt {\n              color: $dv-dark;\n            }\n          }\n\n          &--lst {\n            .tlcrd-body__lst {\n              ul {\n                li {\n                  span {\n                    &.clr {\n                      color: $dv-dark;\n                    }\n                  }\n                }\n\n                &.clrd {\n                  li {\n                    color: $dv-dark;\n                  }\n                }\n              }\n\n              &--clrd {\n                ul {\n                  li {\n                    &:before {\n                      background-color: $dv-dark;\n                    }\n                  }\n                }\n              }\n\n              .blank {\n                ul {\n                  color: $dv-dark;\n\n                  li {\n                    &:after {\n                      background-color: $dv-dark;\n                    }\n                  }\n                }\n              }\n\n              &--styled {\n                ul {\n                  li {\n                    span {\n                      &.cstmzd-blts {\n                        background-color: $dv-dark;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          &--arw {\n            span {\n              color: $dv-dark;\n              border-bottom: 1px solid $dv-dark;\n            }\n          }\n\n          &--tbl {\n            .tlcrd-body__tbl {\n              table {\n                border: 2px solid $dv-dark;\n\n                th,\n                td {\n                  border: 2px solid $dv-dark;\n\n                  .row-info {\n                    color: $dv-dark;\n                  }\n                }\n              }\n            }\n          }\n\n          &--pnts {\n            ul {\n              li {\n                background-color: $dv-dark;\n              }\n            }\n          }\n        }\n\n        .btn-grp {\n          a {\n            i {\n              color: $dv-dark;\n            }\n          }\n        }\n      }\n    }\n\n    &--im {\n      .tlcrd-hdr {\n        background-color: $im-dark;\n\n        &--btm {\n          color: $im-dark;\n          background-color: $im-lighter;\n        }\n      }\n\n      .tlcrd-body {\n        &__blk {\n          .tlcrd-body__hdng {\n            h3 {\n              &:before {\n                background-color: $im-dark;\n              }\n\n              span {\n                color: $im-dark;\n              }\n            }\n\n            &--clrd {\n              h3 {\n                color: $im-dark;\n              }\n            }\n          }\n\n          &--qt {\n            .tlcrd-body__qt {\n              color: $im-dark;\n            }\n          }\n\n          &--lst {\n            .tlcrd-body__lst {\n              ul {\n                li {\n                  span {\n                    &.clr {\n                      color: $im-dark;\n                    }\n                  }\n                }\n\n                &.clrd {\n                  li {\n                    color: $im-dark;\n                  }\n                }\n              }\n\n              &--clrd {\n                ul {\n                  li {\n                    &:before {\n                      background-color: $im-dark;\n                    }\n                  }\n                }\n              }\n\n              .blank {\n                ul {\n                  color: $im-dark;\n\n                  li {\n                    &:after {\n                      background-color: $im-dark;\n                    }\n                  }\n                }\n              }\n\n              &--styled {\n                ul {\n                  li {\n                    span {\n                      &.cstmzd-blts {\n                        background-color: $im-dark;\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n\n          &--arw {\n            span {\n              color: $im-dark;\n              border-bottom: 1px solid $im-dark;\n            }\n          }\n\n          &--tbl {\n            .tlcrd-body__tbl {\n              table {\n                border: 2px solid $im-dark;\n\n                th,\n                td {\n                  border: 2px solid $im-dark;\n\n                  .row-info {\n                    color: $im-dark;\n                  }\n                }\n              }\n            }\n          }\n\n          &--pnts {\n            ul {\n              li {\n                background-color: $im-dark;\n              }\n            }\n          }\n        }\n\n        .btn-grp {\n          a {\n            i {\n              color: $im-dark;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n::ng-deep {\n  .tpdfbtn {\n    padding-inline: 32px;\n\n    @media (max-width:1199px) {\n     padding-right: 8px !important; \n    }\n\n    a {\n      // border: 2px solid #F1F1F2;\n      padding: 3px 9px 6px;\n      border-radius: 4px;\n    }\n\n    &--pr {\n      @media (max-width:1199px) {\n        padding-right: 22px !important; \n       }\n    }\n\n    &--phrs {\n      @media (max-width:1199px) {\n        padding-right: 0px !important; \n\n        a {\n          padding-right: 5px;\n        }\n       }\n    }\n  }\n}\n\n::ng-deep\n.f-flex.prev-next a {\n  padding: 5px 15px;\n  background-color: #fff;\n  border: 1px solid #fff;\n  margin-left: 5px;\n  color: $body-content-color;\n  border-radius: 4px;\n  font-weight: 600;\n  margin-bottom: 5px;\n  min-width: 65px;\n\n  &:hover {\n    background-color: $color-neutral-mid;\n    border-color: $color-neutral-mid;\n  }\n\n  @media (max-width:767px) {\n    margin-bottom: 0;\n  }\n}\n\n\n\n::ng-deep .page-heading {\n\n  &__pdr {\n    padding-right: 35px!important;\n\n    @media (max-width:1199px) {\n      padding-right: 17px!important;\n    }\n\n    &--rt {\n      @media (max-width:1199px) {\n        padding-right: 30px!important;\n      }\n    }\n\n    &--phrs {\n      @media (max-width:1199px) {\n        padding-right: 3px!important;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
